/* eslint-disable no-useless-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-else-return */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  TextField,
  Typography,
  Paper,
  Grid,
  Stack,
  styled,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Divider,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  DialogActions,
  DialogTitle,
  DialogContent,
  FormControlLabel,
  Checkbox,
  Autocomplete,
  Popover,
  DialogContentText,
  Tooltip
} from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import numeral from 'numeral';
import { Form, Formik, useFormikContext } from 'formik';
import React, { useContext, useEffect, useMemo, useState, useLayoutEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import InfoIcon from '@mui/icons-material/Info';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Container } from 'reactstrap';
import imagepreview from '../../../media/upload.png';
import axios from '../../../utils/axios';
import UIContext from '../../../context/UIContext';
import '../../stylemod.css';


const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const shipMentTypesforIN = [
  { label: 'Air Cargo - Srilanka', value: 'ACSL' },
  // { label: 'Air Cargo - India', value: 'ACI' },
];

const shipMentTypesforUK = [
  { label: 'Air Cargo - Srilanka', value: 'ACSL' },
  { label: 'Air Cargo - India', value: 'ACI' },
  { label: 'Sea Cargo - Srilanka', value: 'SCSL' },
];

const shipMentTypesforSL = [
  { label: 'Air Cargo - OverAll', value: 'ACO' },
  // { label: 'Air Cargo - India', value: 'ACI' },
];

const DocTypes = [
  { label: 'Document', value: 'Document' },
  { label: 'NonDocument', value: 'NonDocument' },
];

const pickupTypes = [
  { label: 'Collection', value: 'C' },
  { label: 'Drop', value: 'D' },
];

const DimensionType = [
  { label: 'CM', value: 'CM' },
  { label: 'Inch', value: 'Inch' },
];

const searchByOptions = [
  { label: 'Phone Number', value: 'phonenumber' },
  { label: 'Ledger', value: 'ledger' },
];

const BoxType = [
  { label: 'Standard', value: 'Standard' },
  { label: 'Custom', value: 'Custom' },
];

const idCardTypes = [
  { id: 0, name: 'Select' },
  { id: 1, name: 'Voters ID Card' },
  { id: 2, name: 'Driving License' },
  { id: 3, name: 'PAN Card' },
  { id: 4, name: 'Ration Card' },
  { id: 5, name: 'Aadhar Card' },
  { id: 6, name: 'Passport' },
  { id: 7, name: 'VISA' },
  { id: 8, name: 'Refugee Card' },
  { id: 9, name: 'NIC' },
  { id: 10, name: 'Residence Permit' },
];


const AddBookingForCourierAndCargoOrderCreation = ({ setAddDialogOpenState, getAllData, ledgerPhoneFilterData }) => {
  const configuration = {
    headers: {
      Country: sessionStorage.getItem('Origin'),
    },
  };
   const resetStates = {
  // indital data
  shipMentType: sessionStorage.getItem('Origin') === 'SL' ? 'ACO' : 'ACSL',
  docType: 'NonDocument',
  branch: '',
  NofoBoxes: 1,
  source: 'Export',
  shipper:'',
  // sender details
  senderName: '',
  senderAddr1: '',
  senderAddr2: '',
  senderAddr3: '',
  senderCity: '',
  senderState: '',
  senderCountry: '',
  senderPincode: '',
  senderPhone: '',
  senderEmail: '',
  idCardType: '',
  IdCardNo: '',
  IDcardFile: null,
  // receiver details
  receiverName: '',
  receiverAddr1: '',
  receiverAddr2: '',
  receiverAddr3: '',
  receiverCity: '',
  receiverState: '',
  receiverCountry: '',
  receiverPincode: '',
  receiverPhone: '',
  receiverEmail: '',
  RecidCardType: '',
  RecIdCardNo: '',
  RecIDcardFile: null,
  pickUpType: 'C',
  dimensionType: 'CM',
  customer: '',
  senderAlterPhone: '',
  receiverAlterPhone: '',
  receiverId: '',
  isDraft: false,
  nic:'',
};
  const classes = useStyles();
  const navigate = useNavigate();
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const Origin = sessionStorage.getItem('Origin');
  const [initialValue, setInitialValue] = useState(resetStates);
  const [branchList, setBranchList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [senderStateList, setSenderStateList] = useState([]);
  const [receiverStateList, setReceiverStateList] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedImageFile, setSelectedImageFile] = useState('');
  const [imagePreviews, setImagePreviews] = useState({});
  // Separate sender/receiver image files and previews
  const [senderImageFile, setSenderImageFile] = useState(null);
  const [receiverImageFile, setReceiverImageFile] = useState(null);
  const [senderImagePreview, setSenderImagePreview] = useState('');
  const [receiverImagePreview, setReceiverImagePreview] = useState('');
  const [previewTarget, setPreviewTarget] = useState(null);
  const [editID, setEditID] = useState('');
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openConfirmDialog1, setOpenConfirmDialog1] = useState(false);
  const [boxToDelete, setBoxToDelete] = useState(null);
  const [shipper, setShipper] = useState('');

  // handling image file
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB (adjust as needed)
  const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png'];
  const [boxCount, setBoxCount] = useState(sessionStorage.getItem('Origin') === 'UK' ? 1 : 0);
  const [boxDetails, setBoxDetails] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [bookingStarted, setBookingStarted] = useState(false);
  const [goodsList, setGoodsList] = useState([]);
  const [uomList, setUOMList] = useState([]);
  const [oversizeWarningShown, setOversizeWarningShown] = useState(false);
  const [overweightWarningShown, setOverweightWarningShown] = useState(false);
  const [boxSizeList, setboxSizeList] = useState([]);
  // const [defaultUOMList, setDefaultUOMList] = useState([]);
  const [sameAsSender, setsameAsSender] = useState(false);
  const [receiverCountryErr, setreceiverCountryErr] = useState(false);
  const [senderCountryErr, setsenderCountryErr] = useState(false);
  const [receiverCountryId, setReceiverCountryId] = useState();
  const [shipperPriceData, setShipperPriceData] = useState([]);
  const [cardToggleCourier, setCardToggleCourier] = useState(false);
  const [cardToggleCargo, setCardToggleCargo] = useState(false);
  const [changeContent, setChangeContent] = useState('');
  const [selectedGoods, setSelectedGoods] = useState(null);
  const [documentType, setDocumentType] = useState('NonDocument');
  const [submitConfirmation, setSubmitConfirmation] = useState(false);
  const [resetOpenDialog, setResetOpenDialog] = useState(false);
  const [senderSecondaryCountryId, setSenderSecondaryCountryId] = useState();
  const boxDetailsTempRef = useRef(null); // Holds the initial data // Temporary State to send mail in edit mode
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const contentRef = useRef(null);
  const [cancelRemarksText, setCancelRemarksText] = useState('');
  const [orderCancel, setOrderCancel] = useState('');
  const [searchBy, setSearchBy] = useState(searchByOptions.length > 0 ? searchByOptions[0].value : "");
  const [cusBranchId, setCusBranchId] = useState();
  const [dialogOpen1, setDialogOpen1] = useState(false);
  const [goodsdescription, setgoodsdescription] = useState('');
  const [rate, setrate] = useState('');
  const [hsnCodes, sethsnCodes] = useState('');
  const [active, setactive] = useState(true);
  const [goodsdescriptionErr, setgoodsdescriptionErr] = useState(false);
  const [receiverList, setReceiverList] = useState([]);
  const fieldRefs = useRef({});
  const [isloadvisible, setIsLoadVisible] = useState(true);
  const [openDialogPreview, setOpenDialogPreview] = useState(false);
  const [openConfirmDialogDelete, setOpenConfirmDialogDelete] = useState(false);
  const [imagePreview, setImagePreview] = useState('');
  const [shipperId, setShipperId] = useState(0);
  const [isMinimized, setIsMinimized] = useState(false);
  const [isShipperCardMinimized, setIsShipperCardMinimized] = useState(false);
  const [isDraft, setIsDraft] = useState(false);
  const [boxLoadEnabled, setBoxLoadEnabled] = useState({});
  // const [tc,setTC] = useState(false)
  const [hideUom,setHideUom] = useState(true)

  const [showIdCardChangeDialog, setShowIdCardChangeDialog] = useState({
    sender: false,
    receiver: false
  });
  const [pendingIdCardChanges, setPendingIdCardChanges] = useState({
    sender: null,
    receiver: null
  });
  const[sendPreviewBtn,setSendPreviewBtn] = useState(true);
  const[receivPreviewBtn,setReceivPreviewBtn] = useState(true);

 
  const handleValidationFlow = async (values, validateForm) => {
    // 1. Validate form using properly accessed values
    const errors = await validateForm(values);
    const errorPriority = [
      'senderName', 'senderPhone', 'senderEmail', 'senderAddr1', 'senderCity', 'senderPincode',
      'receiverName', 'receiverPhone', 'receiverAddr1', 'receiverCity', 'receiverPincode',
      'branch', 'IdCardNo', 'RecIdCardNo'
    ];

    // Reorder errors according to priority
    const orderedErrors = {};
    errorPriority.forEach(field => {
      if (errors[field]) {
        orderedErrors[field] = errors[field];
      }
    });


    // 2. Handle error cases
    if (Object.keys(orderedErrors).length > 0) {
      console.log(orderedErrors, 'orderedErrors')
      const firstErrorKey = Object.keys(orderedErrors)[0];
      console.log(orderedErrors[firstErrorKey], 'orderedErrors')
      setTimeout(() => {
        openSnackBar(orderedErrors[firstErrorKey], 'error');
      }, 100);
      fieldRefs.current[firstErrorKey]?.focus();
      return;
    }

    // 3. Your existing special validations
    if (!validateBoxGoodsDetails(boxDetails)) return;

    if (Number(values.senderCountry) !== Number(senderSecondaryCountryId) && sameAsSender === true) {
      setOpenConfirmDialog1(true);
      const selectedCountry = countryList.find(d => Number(d.CountryId) === Number(values.senderCountry));
      const customerCountry = countryList.find(d => Number(d.CountryId) === Number(senderSecondaryCountryId));
      setChangeContent(`There is a mismatch between the sender's country as selected (${selectedCountry.CountryName}) 
          and the one recorded in the customer record (${customerCountry.CountryName}). Please review and update the country as necessary.`);
      return;
    }

    setSubmitConfirmation(true);
  };

  const getIdCardNameById = (id) => {
    // Find the ID card type based on the provided id
    const idCard = idCardTypes.find((card) => Number(card.id) === Number(id));

    // If found, return the name, otherwise return an empty string or any fallback value
    return idCard ? idCard.name : '';
  };

  async function GetBranchList(cntry) {
    showLoading();
    try {
      const requestData = {
        CompanyId: sessionStorage.getItem('CompanyId'),
      };

      const config = {
        headers: {
          Country: cntry,
        },
      };
      const response = await axios.post('Approval/LoginApprovalRoute/GetBranchLog', {
        UserId: sessionStorage.getItem('UserId')
      }, config);
      const {data} = response;
      setBranchList(data.filter((i) => i.webBranch !== 'N'));
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const GetCountryList = async () => {
    try {
      const res = await axios.post('/signup/GetCountryList');
      setCountryList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const getSenderState = async (countryid) => {
    try {
      if (!countryid) return;
      const res = await axios.get(`/signup/GetAllState/${countryid}`);
      setSenderStateList(res.data);
    } catch (err) {
      console.log(err.message);
      setSenderStateList([])
    }
  };

  const getReceiverState = async (countryid) => {
    try {
      if (!countryid) return;
      const res = await axios.get(`/signup/GetAllState/${countryid}`);
      setReceiverStateList(res.data);
    } catch (err) {
      console.log(err.message);
      setReceiverStateList([])
    }
  };


  const getCountryName = (countryid) => {
    const countryObj = countryList.find((obj) => obj.CountryId === countryid);
    if (countryObj) {
      return countryObj.CountryName;
    } else {
      return null;
    }
  };

  const GetGoodsList = async () => {
    try {
      const res = await axios.get('/Transactions/Courier/GetGoodsHelp');
      setGoodsList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const GetUOMList = async () => {
    try {
      const res = await axios.get('/Transactions/Courier/GetUOMHelp');
      setUOMList(res.data);
      // const result = await axios.get('/Transactions/Courier/GetDefaultUOMHelp');
      // setDefaultUOMList(result.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  // Box Size Help
  const GetBoxSizeHelp = async () => {
    try {
      const res = await axios.get('/Transactions/Cargo/GetCargoxBoxSizeHelp');
      setboxSizeList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };
  const GetParameter = async () => {
    try {
      const res = await axios.get(`/master/parameter/GetParameters/${sessionStorage.getItem('CompanyId')}`);
      const hide = res.data[0].IsUOMHidden_Web === 'N' 
      setHideUom(hide);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    GetCountryList();
    GetBranchList(sessionStorage.getItem('Origin'));
    GetGoodsList();
    GetUOMList();
    GetBoxSizeHelp();
    GetParameter();
  }, []);

  const ValidationSchema = useMemo(
    () =>
      Yup.lazy((values) =>
        Yup.object({
          // Initial data validation
          // shipMentType: Yup.string().required('Select Type of Shipment'),
          // docType: Yup.string().required('Select Type of Document'),
          docType: Yup.string().when('shipMentType', {
            is: (shipMentType) => shipMentType !== 'SCSL',
            then: (schema) =>
              schema
                .required('Select Type of Document'),
            otherwise: (schema) => schema.notRequired(),
          }),
          NofoBoxes: Yup.number()
            .required('No of boxes is required')
            .min(1, 'Must be at least 1 box')
            .max(10, 'No more than 10 boxes allowed'),
          customer: Yup.string().required('Customer is required'),
          senderCountry: Yup.string().required('Sender Country is required'),
          receiverCountry: Yup.string().required('Receiver Country is required'),

          // Sender details validation
          ...(bookingStarted && {
            branch: Yup.string().required('Branch is required'),
            senderName: Yup.string().required('Sender name is required'),
            senderAddr1: Yup.string().required('Address line 1 is required'),
            senderAddr2: Yup.string(),
            senderAddr3: Yup.string(),
            senderCity: Yup.string().required('City is required'),
            senderPincode: Yup.string()
              .matches(/^[a-zA-Z0-9 ]+$/, 'Pincode can only contain letters and numbers')
              .max(15, 'Pincode cannot exceed 15 characters')
              .required('Pincode is required'),
            senderPhone: Yup.string()
              .matches(/^\d{9,15}$/, 'Phone number must be between 9 and 15 digits')
              .required('Phone number is required'),
            senderEmail: Yup.string().email('Enter a valid email address').required('Email address is required'),

            // Receiver details validation
            receiverName: Yup.string().required('Receiver name is required'),
            receiverAddr1: Yup.string().required('Address line 1 is required'),
            receiverAddr2: Yup.string(),
            receiverAddr3: Yup.string(),
            receiverCity: Yup.string().required('City is required'),
            receiverPincode: Yup.string()
              .matches(/^[a-zA-Z0-9 ]+$/, 'Pincode can only contain letters and numbers')
              .max(15, 'Pincode cannot exceed 15 characters')
              .required('Pincode is required'),
            receiverPhone: Yup.string()
              .matches(/^\d{9,15}$/, 'Phone number must be between 9 and 15 digits')
              .required('Phone number is required'),
            // receiverEmail: Yup.string().email('Enter a valid email address').required('Email address is required'),

            // Collection details validation
            // pickUpType: Yup.string().required('Pick-up type is required'),
            IdCardNo: Yup.string().when('idCardType', {
              is: (val) => val && val !== '0',
              then: (schema) =>
                schema
                  .required('ID Card Number is required')
                .test(
        'not-all-zeros',
        'ID Card Number is required',
        (value) => {
          if (!value) return true; // Let required validation handle empty values
          return !/^0+$/.test(value); // Rejects strings that contain only zeros
        }
      ),
              otherwise: (schema) => schema.notRequired(),
            }),
            RecIdCardNo: Yup.string().when('RecidCardType', {
              is: (val) => val && val !== '0',
              then: (schema) =>
                schema
                  .required('ID Card Number is required')
                  .test(
        'not-all-zeros',
        'ID Card Number is required',
        (value) => {
          if (!value) return true; // Let required validation handle empty values
          return !/^0+$/.test(value); // Rejects strings that contain only zeros
        }
      ),
              otherwise: (schema) => schema.notRequired(),
            }),
            senderAlterPhone: Yup.string()
              .matches(/^\d{9,15}$/, 'Phone number must be between 9 and 15 digits'),
            receiverAlterPhone: Yup.string()
              .matches(/^\d{9,15}$/, 'Phone number must be between 9 and 15 digits'),
          }),
        })
      ),
    [bookingStarted, sessionStorage.getItem('Origin'), initialValue]
  );

  async function submitCourierOrder(values, isDraftFlag) {
    const data = {
      OPTYPE: 'New',
      // COURIER_NO: "123456",
      COURIER_ID: 0,
      COMPANY_ID: sessionStorage.getItem('CompanyId'),
      BRANCH_ID: values.branch,
      CUSTOMER_ID: values.customer,
      SHIPMENT_TYPE: values.shipMentType,
      DOC_TYPE: values.docType,
      NO_OF_BOXES: values.NofoBoxes,
      SENDER_NAME: values.senderName,
      SENDER_ADDRESS1: values.senderAddr1,
      SENDER_ADDRESS2: values.senderAddr2,
      SENDER_ADDRESS3: values.senderAddr3,
      SENDER_CITY: values.senderCity,
      SENDER_STATE: values.senderState,
      SENDER_COUNTRY: values.senderCountry,
      SENDER_PINCODE: values.senderPincode,
      SENDER_CONTACTNO: values.senderPhone,
      SENDER_EMAILID: values.senderEmail,
      SENDER_IDCARD_TYPE: values.idCardType,
      SENDER_IDCARD_NO: values.IdCardNo,
      SENDER_IDCARD_NAME: getIdCardNameById(values.idCardType) || '',
      SENDER_IDCARD_IMAGE: senderImageFile,
      RECEIVER_NAME: values.receiverName,
      RECEIVER_ADDRESS1: values.receiverAddr1,
      RECEIVER_ADDRESS2: values.receiverAddr2,
      RECEIVER_ADDRESS3: values.receiverAddr3,
      RECEIVER_CITY: values.receiverCity,
      RECEIVER_STATE: values.receiverState,
      RECEIVER_COUNTRY: values.receiverCountry,
      RECEIVER_PINCODE: values.receiverPincode,
      RECEIVER_CONTACTNO: values.receiverPhone,
      RECEIVER_EMAILID: values.receiverEmail,
      RECEIVER_IDCARD_TYPE: values.RecidCardType,
      RECEIVER_IDCARD_NO: values.RecIdCardNo,
      RECEIVER_IDCARD_NAME: getIdCardNameById(values.RecidCardType) || '',
      RECEIVER_IDCARD_IMAGE: receiverImageFile,
      COLLECTION: values.pickUpType,
      COLLECTIONDATE: new Date('1900-01-01').toISOString(),
      TERMSID: 2 ,
      CREATEDBY: sessionStorage.getItem('UserId'),
      CREATEDON: new Date().toISOString(),
      MODIFIEDBY: 0,
      MODIFIEDON: new Date('1900-01-01').toISOString(),
      APPROVAL: isDraftFlag === 'Y' ? 'N' : 'Y',
      APPROVEDBY: 0,
      APPROVEDON: new Date('1900-01-01').toISOString(),
      sameAs_Sender: sameAsSender ? 'Y' : 'N',
      SE_OrderCancelReq: 'N',
      SEreassignId: 0,
      SALESEXECUTIVES: 0,
      DimensionType: values.dimensionType,
      SENDER_ALTERCONTACTNO: values.senderAlterPhone,
      RECEIVER_ALTERCONTACTNO: values.receiverAlterPhone,
      SHIPPER_LINER_NAME: values.shipper,
      SHIPPER_LINER_ID: shipperId,
      SOURCE: values.source,
      IsDraft: isDraftFlag,
    };

    const InsertCourierDtl = boxDetails.map((box, boxIndex) => ({
      OPTYPE: 'New',
      BOXES: box.boxNo, // Total number of boxes
      CARTON_L: box.length || 0,
      CARTON_W: box.width || 0,
      CARTON_H: box.height || 0,
      CUBIC_WEIGHT: box.cubicWeight || '0',
      DimensionType: '',
      GROSS_WEIGHT: box.grossWeight || '0',
      NO_OF_ITEMS: box.noOfItems,
      SINO: (boxIndex + 1).toString(),
      InsertGoodsDtl: box.goods.map((good, goodIndex) => {
        const isValidImage =
          (typeof good.image === 'string' && /\.(jpg|jpeg|png|gif)$/i.test(good.image) && !/^Doc_/i.test(good.image)) || // Exclude filenames starting with "Doc_"
          (typeof good.image === 'object' && good.image instanceof Blob);

        return {
          GOODS_ID: good.GoodsId === undefined || good.GoodsId === '' ? 0 : good.GoodsId,
          GOODS_Name: good.goodsName,
          UOM_ID: good.UOM_Id,
          QUANTITY: good.quantity || 0,
          RATE: good.rate === '' ? 0 : good.rate,
          VALUE: good.value,
          BOX: (boxIndex + 1).toString(),
          ITEM_IMAGE: good.image ? good.image : '',
          ITEM_IMG: isValidImage ? 'I' : '',
          NEW_ITEM: good.newGoods || 'N',
          APPROVAL: 'N',
          APPROVEDBY: 0, // Example ID for approval
          APPROVEDON: new Date('1900-01-01').toISOString(), // Default date
          SINO: (goodIndex + 1).toString(),
        };
      }),
    }));
    const mergedData = {
      ...data,
      InsertCourierDtl,
    };
    const convertToFormData = (obj, form = new FormData(), parentKey = '') => {
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          const value = obj[key];
          const newKey = parentKey ? `${parentKey}[${key}]` : key;

          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              convertToFormData(item, form, `${newKey}[${index}]`);
            });
          } else if (value instanceof File || value instanceof Blob) {
            // Directly append files
            form.append(newKey, value);
          } else if (value && typeof value === 'object') {
            // Recursively handle nested objects
            convertToFormData(value, form, newKey);
          } else {
            // Append scalar values
            // form.append(newKey, value || '');
            form.append(newKey, value != null ? value : '');
          }
        }
      }
      return form;
    };

    const formData = convertToFormData(mergedData);
    const config = {
      headers: {
        Country: sessionStorage.getItem('Origin'),
        'Content-Type': 'multipart/form-data',
      },
    };
    try {
      showLoading();
      const response = await axios.post('Transactions/Courier/InsertCourierHdr', formData, config);
      setOpen(false);
        if(isDraftFlag === 'Y') {
          openSnackBar('Order has been saved as draft successfully!', 'success');
        }
        else {
      openSnackBar('Order has been created successfully!', 'success');
      sendloginForOrderPlaced(values.customer, response.data.courierId, 'CO');
        }
      setAddDialogOpenState(false);
      getAllData();
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function submitCargoOrder(values,isDraftFlag) {
    const data = {
      OPTYPE: 'New',
      // COURIER_NO: "123456",
      CARGO_ID: 0,
      COMPANY_ID: sessionStorage.getItem('CompanyId'),
      BRANCH_ID: values.branch,
      CUSTOMER_ID: values.customer,
      SHIPMENT_TYPE: values.shipMentType,
      DOC_TYPE: values.docType,
      NO_OF_BOXES: values.NofoBoxes,
      SENDER_NAME: values.senderName,
      SENDER_ADDRESS1: values.senderAddr1,
      SENDER_ADDRESS2: values.senderAddr2,
      SENDER_ADDRESS3: values.senderAddr3,
      SENDER_CITY: values.senderCity,
      SENDER_STATE: values.senderState,
      SENDER_COUNTRY: values.senderCountry,
      SENDER_PINCODE: values.senderPincode,
      SENDER_CONTACTNO: values.senderPhone,
      SENDER_EMAILID: values.senderEmail,
      SENDER_IDCARD_TYPE: values.idCardType,
      SENDER_IDCARD_NO: values.IdCardNo,
      SENDER_IDCARD_NAME: getIdCardNameById(values.idCardType) || '',
      SENDER_IDCARD_IMAGE: senderImageFile,
      RECEIVER_NAME: values.receiverName,
      RECEIVER_ADDRESS1: values.receiverAddr1,
      RECEIVER_ADDRESS2: values.receiverAddr2,
      RECEIVER_ADDRESS3: values.receiverAddr3,
      RECEIVER_CITY: values.receiverCity,
      RECEIVER_STATE: values.receiverState,
      RECEIVER_COUNTRY: values.receiverCountry,
      RECEIVER_PINCODE: values.receiverPincode,
      RECEIVER_CONTACTNO: values.receiverPhone,
      RECEIVER_EMAILID: values.receiverEmail,
      RECEIVER_IDCARD_TYPE: values.RecidCardType,
      RECEIVER_IDCARD_NO: values.RecIdCardNo,
      RECEIVER_IDCARD_NAME: getIdCardNameById(values.RecidCardType) || '',
      RECEIVER_IDCARD_IMAGE: receiverImageFile,
      COLLECTION: values.pickUpType,
      COLLECTIONDATE: new Date('1900-01-01').toISOString(),
      TERMSID: 2 ,
      CREATEDBY: sessionStorage.getItem('UserId'),
      CREATEDON: new Date().toISOString(),
      MODIFIEDBY: 0,
      MODIFIEDON: new Date('1900-01-01').toISOString(),
      APPROVAL: isDraftFlag === 'Y' ? 'N' : 'Y',
      APPROVEDBY: sessionStorage.getItem('UserId'),
      APPROVEDON: new Date().toISOString(),
      sameAs_Sender: sameAsSender ? 'Y' : 'N',
      SE_OrderCancelReq: 'N',
      SEreassignId: 0,
      SALESEXECUTIVES: 0,
      SENDER_ALTERCONTACTNO: values.senderAlterPhone,
      RECEIVER_ALTERCONTACTNO: values.receiverAlterPhone,
      SHIPPER_LINER_NAME: values.shipper,
      SHIPPER_LINER_ID: shipperId,
      SOURCE: values.source,
      IsDraft: isDraftFlag,
      NIC: values.nic,
    };

    const InsertCargoDtl = boxDetails.map((box, boxIndex) => ({
      OPTYPE: 'New',
      BOX_SELECT: box.BoxType,
      BOX_TYPEID: box.BOXTYPEID,
      BOX_TYPE: box.BoxSize,
      BoxNameType: box.BoxType === 'Custom' ? `${box.length} X ${box.width} X ${box.height}` : box.BoxNameType || '',
      BOXSIZEID: box.BOXSIZEID || 0,
      BOXES: box.boxNo, // Total number of boxes
      CARTON_L: box.length || 0,
      CARTON_W: box.width || 0,
      CARTON_H: box.height || 0,
      CUBIC_WEIGHT: box.cubicWeight || '0',
      DIMENSION: box.dimensionType,
      GROSS_WEIGHT: box.grossWeight || '0',
      NO_OF_ITEMS: box.noOfItems,
      RatePer: box.RatePer,
      Rate: box.Rate || 0,
      Duty: box.Duty || 0,
      Profit: box.Profit || 0,
      SINO: (boxIndex + 1).toString(),
      InsertCargoGoodsDtl: box.goods.map((good, goodIndex) => {
        const isValidImage =
          (typeof good.image === 'string' && /\.(jpg|jpeg|png|gif)$/i.test(good.image) && !/^Doc_/i.test(good.image)) ||
          (typeof good.image === 'object' && good.image instanceof Blob);

        return {
          GOODS_ID: good.GoodsId,
          GOODS_Name: good.goodsName,
          UOM_ID: good.UOM_Id,
          QUANTITY: good.quantity || 0,
          RATE: good.rate === '' ? 0 : good.rate,
          VALUE: good.value,
          BOX: (boxIndex + 1).toString(),
          ITEM_IMAGE: good.image ? good.image : '',
          ITEM_IMG: isValidImage ? 'I' : '',
          NEW_ITEM: good.newGoods || 'N',
          APPROVAL: good.APPROVAL,
          APPROVEDBY: sessionStorage.getItem('UserId'),
          APPROVEDON: new Date().toISOString(),
          SINO: (goodIndex + 1).toString(),
        };
      }),
    }));

    const mergedData = {
      ...data,
      InsertCargoDtl,
    };
    const convertToFormData = (obj, form = new FormData(), parentKey = '') => {
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          const value = obj[key];
          const newKey = parentKey ? `${parentKey}[${key}]` : key;

          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              convertToFormData(item, form, `${newKey}[${index}]`);
            });
          } else if (value instanceof File || value instanceof Blob) {
            // Directly append files
            form.append(newKey, value);
          } else if (value && typeof value === 'object') {
            // Recursively handle nested objects
            convertToFormData(value, form, newKey);
          } else {
            // Append scalar values
            form.append(newKey, value != null ? value : '');
          }
        }
      }
      return form;
    };

    const formData = convertToFormData(mergedData);

    const config = {
      headers: {
        Country: sessionStorage.getItem('Origin'),
        'Content-Type': 'multipart/form-data',
      },
    };
    try {
      showLoading();
      const response = await axios.post('Transactions/Cargo/InsertCargoHdr', formData, config);
      setOpen(false);
      if(isDraftFlag === 'Y') {
        openSnackBar('Order has been saved as draft successfully!', 'success');
      } else {
        openSnackBar('Order has been created successfully!', 'success');
        sendloginForOrderPlaced(values.customer, response.data.cargoId, 'CA');
      }
      
      setAddDialogOpenState(false);
      getAllData();
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function sendloginForOrderPlaced(cusID, OrderId, FormType) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: 'OrderCreated',
        customerid: cusID,
        Type: FormType,
        Order_Id: OrderId,
      });
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const handleCountryChangeSender = (selectedCountry, handleChange) => {
    const selectedSenderCountryId = selectedCountry.CountryId;
    getSenderState(selectedSenderCountryId);
    handleChange({
      target: {
        name: 'senderCountry',
        value: selectedSenderCountryId,
      },
    });
  };

  const handleCountryChangereceiver = (selectedCountry, handleChange) => {
    const selectedCountryId = selectedCountry.CountryId;
    getReceiverState(selectedCountryId);
    handleChange({
      target: {
        name: 'receiverCountry',
        value: selectedCountryId,
      },
    });
  };

  // Helper functions for dimension and weight validation (for shipment types !== SCSL)
  const checkOversizeCondition = (boxes) => {
    return boxes.some(box => 
      (box.length && box.length >= 100) || 
      (box.width && box.width >= 100) || 
      (box.height && box.height >= 100)
    );
  };

  const checkOverweightCondition = (boxes) => {
    return boxes.some(box => box.grossWeight && box.grossWeight >= 31);
  };

  const showOversizeWarning = () => {
    openSnackBar('Additional charges will be applied for oversized shipments', 'warning');
  };

  const showOverweightWarning = () => {
    openSnackBar('Additional charges will be applied for overweight shipments', 'warning');
  };

  const toggleAccordion = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const toggleAccordionTrue = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: true }));
  };

  const handleIdFileChange = (event, target) => {
    const file = event.target.files[0];
    if (!file) return;

    // File size validation
    if (file.size > MAX_FILE_SIZE) {
      alert('File size exceeds the maximum allowed size (5 MB).');
      return;
    }

    // File type validation
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      alert('Invalid file type. Allowed types are JPEG, PNG, and PDF.');
      return;
    }

    // Update the selected file and preview depending on whether it's sender or receiver
    if (target === 'sender') {
      setSenderImageFile(file);
      setSenderImagePreview(URL.createObjectURL(file));
    } else if (target === 'receiver') {
      setReceiverImageFile(file);
      setReceiverImagePreview(URL.createObjectURL(file));
    } else {
      // fallback: keep old single-file behavior
      setSelectedImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleOpenDialogPreview = (target) => {
    setPreviewTarget(target);
    setOpenDialogPreview(true);
  };

  const handleCloseDialogPreview = () => {
    setOpenDialogPreview(false);
    setPreviewTarget(null);
  };

  const handleCloseConfirmDialogDelete = () => {
    setOpenConfirmDialogDelete(false);
  };

  const handleOpenConfirmDialogDelete = () => {
    setOpenConfirmDialogDelete(true);
  };

  const handleBoxCountChange = (value, shiptype) => {
    showLoading();
    const uom = uomList.find(i => i.DefaultUOM === 'Y') || { UOM_Id: 0, UOM_Description: '' };
    if (shiptype !== 'SCSL') {
      setBoxCount(value);
      const boxes = Array.from({ length: value }, (_, index) => ({
        boxNo: index + 1,
        length: '',
        width: '',
        height: '',
        // dimensionType: 'CM',
        cubicWeight: '',
        grossWeight: '',
        noOfItems: 1,
        goods: [
          {
        goodsName: '',
        uom: '',
        UOM_Id: uom.UOM_Id,
        UOM_Description: uom.UOM_Description,
        quantity: '',
        rate: '',
        value: '',
        newGoods: 'N',
        image: null,
        GoodsId: '0',
      }
        ],
      }));
      setBoxDetails(boxes);

    } else {
      setBoxCount(value);
      const boxes = Array.from({ length: value }, (_, index) => ({
        boxNo: index + 1,
        BoxSize: '',
        BoxType: '',
        length: '',
        width: '',
        height: '',
        dimensionType: 'CM',
        cubicWeight: '',
        grossWeight: '',
        noOfItems: 1,
        goods: [{
        goodsName: '',
        uom: '',
        UOM_Id: uom.UOM_Id,
        UOM_Description: uom.UOM_Description,
        quantity: '',
        rate: '',
        value: '',
        newGoods: 'N',
        image: null,
        GoodsId: '0',
      }],
        RatePer: 'CBM',
        Rate: '',
        Duty: '',
        Profit: '',
        ActRate: '',
        actualRate: ''
      }));
      setBoxDetails(boxes);
    }
      const initialLoadState = {};
  for (let i = 0; i < value; i++) {
    initialLoadState[i] = true; // Disable load for all boxes
  }
   toggleAccordion(0);
  setBoxLoadEnabled(initialLoadState);
    hideLoading();
  };

  const handleAddBox = async (setFieldValue, values) => {
    // showLoading();
    const uom = uomList.find(i => i.DefaultUOM === 'Y') || 0;
    setInitialValue(values);
    if (values.shipMentType !== 'SCSL') {
      setBoxDetails((prevDetails) => {
        const newBoxIndex = prevDetails.length;
        const updatedBoxes = [
          ...prevDetails,
          {
            boxNo: prevDetails.length + 1, // Ensure the boxNo is incremented correctly as a number
            length: '',
            width: '',
            height: '',
            // dimensionType: 'CM',
            cubicWeight: '',
            grossWeight: '',
            noOfItems: 1,
            goods: [{
            goodsName: '',
            uom: '',
            UOM_Id: uom.UOM_Id,
            UOM_Description: uom.UOM_Description,
            quantity: '',
            rate: '',
            value: '',
            newGoods: 'N',
            image: null,
            GoodsId: '0',
          }],
          },
        ];
            setBoxLoadEnabled(prev => ({
      ...prev,
      [newBoxIndex]: true
    }));
         toggleAccordion(newBoxIndex);
        return updatedBoxes; // Update the box count state
      });
    } else {
      setBoxDetails((prevDetails) => {
        const newBoxIndex = prevDetails.length;
        const updatedBoxes = [
          ...prevDetails,
          {
            boxNo: prevDetails.length + 1,
            BoxSize: '',
            BoxType: '',
            length: '',
            width: '',
            height: '',
            dimensionType: 'CM',
            cubicWeight: '',
            grossWeight: '',
            noOfItems: 1,
            goods: [{
            goodsName: '',
            uom: '',
            UOM_Id: uom.UOM_Id,
            UOM_Description: uom.UOM_Description,
            quantity: '',
            rate: '',
            value: '',
            newGoods: 'N',
            image: null,
            GoodsId: '0',
          }],
            RatePer: 'CBM',
            Rate: '',
            Duty: '',
            Profit: '',
            ActRate: '',
            actualRate: ''
          },
        ];
            setBoxLoadEnabled(prev => ({
      ...prev,
      [newBoxIndex]: true
    }));
         toggleAccordion(newBoxIndex);
        return updatedBoxes; // This ensures a new array is returned
      });
    }
    setTimeout(async () => {
      await new Promise((resolve) => {
        setFieldValue('NofoBoxes', boxDetails.length + 1, () => resolve());
      });
    }, 1000);
    // hideLoading();
  };

  const handleAddGoods = (boxIndex, newFlag) => {
    showLoading();
    const uom = uomList.find(i => i.DefaultUOM === 'Y') || 0
    const updatedBoxDetails = [...boxDetails];
    updatedBoxDetails[boxIndex].goods.push({
      goodsName: '',
      uom: '',
      UOM_Id: uom.UOM_Id,
      UOM_Description: uom.UOM_Description,
      quantity: '',
      rate: '',
      value: '',
      newGoods: newFlag,
      image: null,
    });
    setBoxDetails(updatedBoxDetails);
    updatedBoxDetails[boxIndex].noOfItems = updatedBoxDetails[boxIndex].goods.length;
    hideLoading();
  };

  const handleDeleteGoods = (boxIndex, goodsIndex) => {
    const updatedBoxDetails = [...boxDetails];
    updatedBoxDetails[boxIndex].goods.splice(goodsIndex, 1);
    updatedBoxDetails[boxIndex].noOfItems = updatedBoxDetails[boxIndex].goods.length;

    setBoxDetails(updatedBoxDetails);
    setImagePreviews((prevPreviews) => {
      const imgPreviews = { ...prevPreviews };
      delete imgPreviews[`${boxIndex}-${goodsIndex}`];
      const updatedPreviews = Object.fromEntries(
        Object.entries(imgPreviews).map(([key, val], i) => {
          const newKey = key.split('-').map(Number);
          if (newKey[1] >= goodsIndex) newKey[1] -= 1;
          return [newKey.join('-'), val];
        })
      );
      return updatedPreviews;
    });
  };

  const handleGoodsChange = (boxIndex, goodsIndex, field, value) => {
    showLoading();
    const updatedBoxDetails = [...boxDetails];
    if (field === 'goods') {
      updatedBoxDetails[boxIndex].goods[goodsIndex] = {
        ...updatedBoxDetails[boxIndex].goods[goodsIndex],
        GoodsName: value.GoodsName,
        GoodsId: value.GoodsId,
      };
    } else if (field === 'uom') {
      updatedBoxDetails[boxIndex].goods[goodsIndex] = {
        ...updatedBoxDetails[boxIndex].goods[goodsIndex],
        UOM_Description: value.UOM_Description,
        UOM_Id: value.UOM_Id || 0,
      };
    } else {
      updatedBoxDetails[boxIndex].goods[goodsIndex][field] = value;
    }

    // Recalculate the total value of the goods in the box
    if (field === 'quantity' || field === 'rate') {
      const updatedGoods = updatedBoxDetails[boxIndex].goods[goodsIndex];
      updatedGoods.value = parseFloat((updatedGoods.quantity * updatedGoods.rate).toFixed(2))
    }
    setBoxDetails(updatedBoxDetails);
    hideLoading();
  };

  const getTotalValue = (boxIndex) => {
    const box = boxDetails[boxIndex];
    return parseFloat(
      box.goods.reduce((total, goods) => Number(total) + Number(goods.value), 0).toFixed(2)
    );
  };

  const resetBooking = () => {
    showLoading();
    setInitialValue(resetStates);
    setBoxCount(0);
    setBoxDetails([]);
    setImagePreviews({});
    setSelectedImageFile('');
    setBookingStarted(false);
    hideLoading();
  };

  const handleOpenConfirmDialog = (boxIndex) => {
    setBoxToDelete(boxIndex); // Set the box to be deleted
    setOpenConfirmDialog(true); // Open the confirmation dialog
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false); // Close the confirmation dialog
    setBoxToDelete(null);
  };

  const handleCloseConfirmDialog1 = () => {
    setOpenConfirmDialog1(false); // Close the confirmation dialog
    setsameAsSender(false);
  };

  const handleSamesAsAddress = async (e, setFieldValue, values) => {
    const isChecked = e.target.checked;
    setsameAsSender(isChecked);
    if (isChecked) {
      try {
        // if (!20629) return;
        const res = await axios.get(`/Transactions/Courier/GetSameAsAddress/${values.customer}`);
        const {data} = res;
        data.forEach(async (senderData) => {
          let state = {};
          if (senderData.CusCountryId && senderData.CusCountryId !== 0) {
            try {
              getSenderState(senderData.CusCountryId);
              const res = await axios.get(`/signup/GetAllState/${senderData.CusCountryId}`);
              state = res.data.find((d) => Number(d.StateId) === Number(senderData.CusstateId));
            } catch {
              console.log('error');
            }
          }
          setSenderSecondaryCountryId(Number(senderData.CusCountryId))
          if (Number(values.senderCountry) === Number(senderData.CusCountryId)) {
            setsenderCountryErr(false);
            setFieldValue('senderName', senderData.CustomerName || '');
            setFieldValue('senderAddr1', senderData.Address1 || '');
            setFieldValue('senderAddr2', senderData.Address2 || '');
            setFieldValue('senderAddr3', senderData.Address3 || '');
            setFieldValue('senderCity', senderData.City || '');
            setFieldValue('senderState', state ? state.StateId : '');
            // setFieldValue('senderCountry', senderData.CusCountryId || '');
            setFieldValue('senderPincode', senderData.Zipcode || '');
            setFieldValue('senderPhone', senderData.Phone || '');
            setFieldValue('senderEmail', senderData.EmailId || '');
            setFieldValue('senderAlterPhone', senderData.AlterPhone || '');
          } else {
            setOpenConfirmDialog1(true);
            const selectedCountry = countryList.find((d) => Number(d.CountryId) === Number(values.senderCountry));
            const customerCountry = countryList.find((d) => Number(d.CountryId) === Number(senderData.CusCountryId));
            setChangeContent(`There is a mismatch between the sender's country as selected (${selectedCountry.CountryName}) 
            and the one recorded in the customer record (${customerCountry.CountryName}). Please review and update the country as necessary.`);
          }
        });
      } catch (err) {
        console.log(err.message);
      }
    } else {
      setSenderSecondaryCountryId(Number(values.senderCountry))
      // If unchecked, reset the sender data fields
      setFieldValue('senderName', '');
      setFieldValue('senderAddr1', '');
      setFieldValue('senderAddr2', '');
      setFieldValue('senderAddr3', '');
      setFieldValue('senderCity', '');
      setFieldValue('senderState', '');
      // setFieldValue('senderCountry', '');
      setFieldValue('senderPincode', '');
      setFieldValue('senderPhone', '');
      setFieldValue('senderEmail', '');
      setFieldValue('senderAlterPhone', '');
    }
  };

  const validateBoxDetails = (box, boxIndex, shiptype) => {
    const errors = [];

    if (box.length === '' || Number(box.length) === 0) {
      errors.push(`Row ${boxIndex + 1}: Length is required.`);
    }

    if (box.width === '' || Number(box.width) === 0) {
      errors.push(`Row ${boxIndex + 1}: Width is required.`);
    }

    if (box.height === '' || Number(box.height) === 0) {
      errors.push(`Row ${boxIndex + 1}: Height is required.`);
    }

    if (box.grossWeight === '' || Number(box.grossWeight) === 0) {
      errors.push(`Row ${boxIndex + 1}: Gross Weight is required.`);
    }

    if (box.noOfItems === '' || Number(box.noOfItems) === 0) {
      errors.push(`Row ${boxIndex + 1}: No of Items is required.`);
    }

    if (shiptype === 'SCSL') {
      if (box.boxType === '' || box.boxType === null) {
        errors.push(`Box ${boxIndex + 1}: Select Box is required.`);
      }

      if (box.boxSize === '' || box.boxSize === null) {
        errors.push(`Box ${boxIndex + 1}: Box Size is required.`);
      }
    }

    if (errors.length > 0) {
      alert(errors.join('\n'));
      return false; // Validation failed for this row
    }

    return true; // All validations passed
  };

  const validateBoxGoodsDetails = (boxDetails) => {
    // Validate boxDetails
    const errors = [];

    boxDetails.forEach((box, boxIndex) => {
      if (box.length === '' || Number(box.length) === 0) {
        errors.push(`Box ${boxIndex + 1}: Length is required.`);
      }

      if (box.width === '' || Number(box.width) === 0) {
        errors.push(`Box ${boxIndex + 1}: Width is required.`);
      }

      if (box.height === '' || Number(box.height) === 0) {
        errors.push(`Box ${boxIndex + 1}: Height is required.`);
      }

      if (box.grossWeight === '' || Number(box.grossWeight) === 0) {
        errors.push(`Box ${boxIndex + 1}: Gross Weight is required.`);
      }

      if (box.noOfItems === '' || Number(box.noOfItems) === 0) {
        errors.push(`Box ${boxIndex + 1}: No of Items is required.`);
      }

      // Validate goods within the box
      if (!box.goods || box.goods.length === 0) {
        errors.push(`Box ${boxIndex + 1}: Enter goods details.`);
      } else {
        // Validate goods within the box
        box.goods.forEach((good, goodIndex) => {
          const goodsNameExists = 'GoodsName' in good;
          const goodsIdExists = 'GoodsId' in good;
          if (
            good.newGoods === 'Y'
              ? good.goodsName === ''
              : (goodsNameExists ? good.GoodsName === '' : false) || !goodsIdExists || Number(good.GoodsId) === 0
          ) {
            errors.push(`Box ${boxIndex + 1}, Good ${goodIndex + 1}: Goods Name is required.`);
          }

          if (good.quantity === '' || Number(good.quantity) === 0) {
            errors.push(`Box ${boxIndex + 1}, Good ${goodIndex + 1}: Quantity is required.`);
          }
        });
      }
    });

    // Show errors if any
    if (errors.length > 0) {
      alert(errors.join('\n'));
      return false; // Stop the process if validation fails
    }

    return true; // All validations passed
  };


  const GetCourierShipperPrice = async (data, receiverCountryids, cusBranchids, docType) => {
    const result = data.reduce(
      (acc, item) => {
        const ceilingCubicWeight = Math.ceil(item.cubicWeight || 0);
        const ceilingGrossWeight = Math.ceil(item.grossWeight || 0);
        const higherWeight = Math.max(ceilingCubicWeight, ceilingGrossWeight);
        acc.totalWeight += higherWeight;
        return acc;
      },
      { totalWeight: 0 }
    );
    try {
      const res = await axios.get(
        `/Transactions/Courier/GetAllCourierShipperPrice/${sessionStorage.getItem(
          'CompanyId'
        )}/${cusBranchids || cusBranchId}/${receiverCountryids || receiverCountryId}/${result.totalWeight}/${docType || documentType}`,
        configuration
      );
      if (res.data.length > 0) {
        setShipperPriceData(res.data);
        setCardToggleCourier(true);
      } else {
        setShipperPriceData([]);
        setCardToggleCourier(false);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  // const GetCargoShipperPrice = async (data, receiverCountryids) => {
  //   const result = data.reduce(
  //     (acc, item) => {
  //       const ceilingCubicWeight = Number(item.cubicWeight) || 0;
  //       acc.totalWeight += ceilingCubicWeight;
  //       return acc;
  //     },
  //     { totalWeight: 0 }
  //   );
  //   try {
  //     const res = await axios.get(
  //       `/Transactions/Cargo/GetAllCargoShipperPrice/${receiverCountryids || receiverCountryId}/${Number(
  //         result.totalWeight.toFixed(2)
  //       )}`,
  //       configuration
  //     );
  //     if (res.data.length > 0) {
  //       setShipperPriceData(res.data);
  //       setCardToggleCargo(true);
  //     } else {
  //       setShipperPriceData([]);
  //       setCardToggleCargo(false);
  //     }
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };

  // const GetCargoShipperPrice1 = async (val, receiverCountryids, index = null, boxCollection, isEditMode) => {
  //   try {
  //     if (index !== null) {
  //       const res = await axios.get(
  //         `/Transactions/Cargo/GetAllCargoShipperPrice/${receiverCountryids || receiverCountryId}/${Number(val.toFixed(2))}`,
  //         configuration
  //       );

  //       const value = res.data.length > 0 ? res.data[0] : {};

  //       setBoxDetails((prevBoxes) => {
  //         const updatedBoxes = prevBoxes.map((box, i) =>
  //           i === index
  //             ? {
  //               ...box,
  //               RatePer: "CBM",
  //               Rate: value.Rate || 0,
  //               Duty: value.duty || 0,
  //               Profit: value.profit || 0,
  //               ActRate: value.ActRate || 0,
  //               actualRate: value.actualRate || 0,
  //             }
  //             : box
  //         );

  //         const allEmpty = updatedBoxes.every(
  //           value =>
  //             (value.Rate === "" || value.Rate === "0" || value.Rate === 0) &&
  //             (value.Duty === "" || value.Duty === "0" || value.Duty === 0) &&
  //             (value.Profit === "" || value.Profit === "0" || value.Profit === 0)
  //         );
  //         const isEmpty = !value.Rate && !value.duty && !value.profit
  //         setCardToggleCargo(!(isEmpty && allEmpty));

  //         return updatedBoxes;
  //       });
  //     } else if (!isEditMode) {
  //       const requests = boxCollection.map(async (box, i) => {
  //         const cubicWeight = Number(box.cubicWeight);

  //         if (Number.isNaN(cubicWeight) || cubicWeight <= 0) {
  //           return box;
  //         }

  //         const res = await axios.get(
  //           `/Transactions/Cargo/GetAllCargoShipperPrice/${receiverCountryids || receiverCountryId}/${Number(cubicWeight.toFixed(2))}`,
  //           configuration
  //         );

  //         const value = res.data.length > 0 ? res.data[0] : {};
  //         return {
  //           ...box,
  //           RatePer: "CBM",
  //           Rate: value.Rate || 0,
  //           Duty: value.duty || 0,
  //           Profit: value.profit || 0,
  //           ActRate: value.ActRate || 0,
  //           actualRate: value.actualRate || 0,
  //         };
  //       });

  //       const updatedBoxes = await Promise.all(requests);
  //       setBoxDetails(updatedBoxes);
  //       // const allEmpty = updatedBoxes.every(box => !box.Rate && !box.Duty && !box.Profit && !box.ActRate && !box.actualRate);
  //       const allEmpty = updatedBoxes.every(
  //         value =>
  //           (value.Rate === "" || value.Rate === "0" || value.Rate === 0) &&
  //           (value.Duty === "" || value.Duty === "0" || value.Duty === 0) &&
  //           (value.Profit === "" || value.Profit === "0" || value.Profit === 0)
  //       );
  //       setCardToggleCargo(!allEmpty);
  //     } else if (isEditMode) {
  //       setBoxDetails(boxCollection);
  //       const isEmpty = boxCollection.every(
  //         value =>
  //           (value.Rate === "" || value.Rate === "0" || value.Rate === 0) &&
  //           (value.Duty === "" || value.Duty === "0" || value.Duty === 0) &&
  //           (value.Profit === "" || value.Profit === "0" || value.Profit === 0)
  //       );
  //       setCardToggleCargo(!isEmpty);
  //     }
  //   } catch (err) {
  //     console.error("Error updating box prices:", err);
  //   }
  // };

  // Added by harel on 31-05-2025
  const GetCargoNewShipperPrice = async (receiverCountryids, boxCollection) => {
    try {
      const boxData = boxCollection || boxDetails
      const output = boxData.map(box => ({
        CountryId: receiverCountryids,
        BoxSizeId: parseInt(box.BOXSIZEID, 10),
        CBM: box.cubicWeight,
        BoxType: box.BoxType
      }));
      const res = await axios.post(`/Transactions/Cargo/GetAllCargoNewShipperPrice`,
        {
          output
        }, configuration);
      if (res.data.output.length > 0) {
        setShipperPriceData(res.data)
        setCardToggleCargo(true);
      } else {
        setShipperPriceData([])
      }

    } catch (err) {
      console.error("Error updating box prices:", err);
    }
  };

  const startsWithFilter = createFilterOptions({
    matchFrom: 'any', // The Filter Type are start and any
    stringify: (option) => option.GoodsName || '', // Determines the field to filter
  });

  const handleOpenDialog1 = () => {
    setDialogOpen1(true);
  };

  const handleCloseDialog1 = () => {
    setDialogOpen1(false);
    setgoodsdescription('');
    setactive('Y');
    sethsnCodes('');
    setrate('');
  };

  const InsertGoodsMst = async () => {
    try {
      if (goodsdescription.length !== 0) {
        const res = await axios.post('/Master/goods/InsertNewGoods', {
          GoodsName: goodsdescription,
          Price: rate,
          HSCode: hsnCodes,
          Active: active ? 'Y' : 'N',
          CreatedBy: sessionStorage.getItem('UserId'),
        });

        if (res.status === 200) {
          openSnackBar('Added Successfully!', 'success');
          GetGoodsList(); // Fetch updated goods list
          setDialogOpen1(false); // Close the dialog
          setgoodsdescription(''); // Reset fields
          sethsnCodes('');
          setrate('');
          setactive(true);
        }
      } else {
        if (goodsdescription.length === 0) {
          setgoodsdescriptionErr(true);
        }
        setTimeout(() => {
          setgoodsdescriptionErr(false);
        }, 1000);
      }
    } catch (e) {
      const errorMessage = e.response?.data;

      if (errorMessage && errorMessage.includes('GoodsName Already Exists')) {
        openSnackBar('GoodsDescription Already Exists', 'error');
      } else {
        openSnackBar(errorMessage || 'Something Went Wrong. Try Again!', 'error');
      }
    }
  };

  const handleBoxSizeChange = (index, field, value, values) => {
    showLoading();
    const updatedBoxes = [...boxDetails];
    const rawCubicWeight =
      value.DIMENSION === 'CM'
        ? (Number(value.BOXHEIGHT) / 100) * (Number(value.BOXLENGTH) / 100) * (Number(value.BOXWIDTH) / 100)
        : Number(value.BOXHEIGHT) * 0.0254 * (Number(value.BOXLENGTH) * 0.0254) * (Number(value.BOXWIDTH) * 0.0254);
    if (field === 'BoxSize') {
      updatedBoxes[index] = {
        ...updatedBoxes[index],
        length: value.BOXLENGTH,
        width: value.BOXWIDTH,
        height: value.BOXHEIGHT,
        dimensionType: value.DIMENSION,
        grossWeight: '',
        BOXTYPEID: value.BOXTYPEID,
        BoxSize: value.BOXTYPE,
        BoxNameType: value.BOXSIZE,
        BOXSIZEID: value.BOXSIZEID,
        cubicWeight: parseFloat(rawCubicWeight.toFixed(2)),
        BoxType: 'Standard',
        //  - ${value.BOXSIZE}
      };
    }

    setBoxDetails(updatedBoxes);
    // GetCargoShipperPrice(updatedBoxes);
    // GetCargoShipperPrice1(parseFloat(rawCubicWeight.toFixed(2)), null, index);
    GetCargoNewShipperPrice(values.receiverCountry, updatedBoxes);
    hideLoading();
  };

  const GetReceiverList = async (val, cusId) => {
    try {
      const config = {
        headers: {
          Country: sessionStorage.getItem('Origin'),
        },
      };
      let response
      if (val !== 'SCSL') {
        response = await axios.post(`/Transactions/Courier/GetAllCourierReceiverHelp`, {
          CustomerId: cusId
        }, sessionStorage.getItem('CompanyId'), config);
      } else {
        response = await axios.post(`/Transactions/Cargo/GetAllCargoReceiverHelp`, {
          CustomerId: cusId
        }, sessionStorage.getItem('CompanyId'), config);
      }
      setReceiverList(response.data);
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }}>
        <Container component={Paper} elevation={2}>
          <Divider sx={{ my: 2 }} variant="middle">
            <Chip label="Basic Details" size="small" color="primary" variant="outlined" />
          </Divider>
          <Formik
            validationSchema={ValidationSchema}
            initialValues={{ ...initialValue, boxDetails, senderSecondaryCountryId }}
            onSubmit={async (values, { resetForm, setErrors, setFieldError }) => {
              if (values.shipMentType !== 'SCSL') {
                await submitCourierOrder({ ...initialValue, ...values },'N');
              } else {
                await submitCargoOrder({ ...initialValue, ...values },'N');
              }
              resetForm();
            }}
          >
            {({
              submitForm,
              touched,
              values,
              errors,
              handleChange,
              handleBlur,
              isSubmitting,
              setFieldTouched,
              validateForm,
              setFieldValue,
              resetForm,
              setErrors,
              setTouched,
            }) => (
              <Form>
                <Grid container spacing={2} p={1} rowSpacing={3} columnSpacing={4}>
                  <Grid item md={3} xs={12}>
                    {/* Status Filter */}
                    <TextField
                      fullWidth
                      select
                      label="Search by"
                      name="searchBy"
                      value={searchBy}
                      onChange={(e) => {
                        setSearchBy(e.target.value)
                      }}
                      variant="outlined"
                      size="small"
                    >
                      {searchByOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth size="small">
                      <Autocomplete
                        key={searchBy}
                        options={ledgerPhoneFilterData}
                        getOptionLabel={(customer) =>
                          searchBy === 'phonenumber' ? customer.Phone : customer.CUSTOMERNAME
                        }
                        renderOption={(props, customer) => (
                          <li {...props} key={customer.CUSTOMERID}>
                            {searchBy === 'phonenumber' ? customer.Phone : customer.CUSTOMERNAME}
                          </li>
                        )}
                        isOptionEqualToValue={(customer) => customer.CUSTOMERID === values.customer}
                        value={ledgerPhoneFilterData.find((customer) => customer.CUSTOMERID === values.customer) || null}
                        name="ledger"
                        onChange={(event, value) => {
                          setFieldValue('customer', value ? value.CUSTOMERID : '');
                          setCusBranchId(value?.BranchId || '')
                          GetReceiverList(values.shipMentType, value.CUSTOMERID)
                        }}
                        size="small"
                        onBlur={() => setFieldTouched('customer', true)}
                        required
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={searchBy === 'phonenumber' ? 'Phone Number' : 'Ledger'}
                            error={Boolean(touched.customer && errors.customer)}
                            helperText={touched.customer && errors.customer ? errors.customer : ''}
                            FormHelperTextProps={{ style: { color: 'red' } }}
                          />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Shipment Type</InputLabel>
                      <Select
                        value={values.shipMentType}
                        name="shipMentType"
                        size="small"
                        label="Shipment Type"
                        onChange={(e) => {
                          handleChange(e)
                          GetReceiverList(e.target.value, values.customer)
                          console.log(e.target.value, 'e.target.value')
                        }}
                        onBlur={handleBlur}
                        error={touched.shipMentType && !!errors.shipMentType}
                        disabled={bookingStarted}
                        required
                      >
                        {sessionStorage.getItem('Origin') === 'IN'
                          ? shipMentTypesforIN.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))
                          : sessionStorage.getItem('Origin') === 'UK'
                          ? shipMentTypesforUK.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))
                        : shipMentTypesforSL.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                      </Select>
                      {touched.shipMentType && errors.shipMentType && (
                        <Typography variant="caption" color="error" className="shake-helper-text" margin="4px 0 0 14px">
                          {errors.shipMentType}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                   <Grid item md={3} xs={12}>
      <FormControl fullWidth size="small">
        {/* <Autocomplete
          options={shipperPriceData.map(item => item.ShipperLinerName) || []}
          value={values.shipper || ''}
          onChange={(event, newValue) => {
            setFieldValue('shipper', newValue || '');
            if (newValue) {
              const selectedShipper = shipperPriceData.find(
                s => s.ShipperLinerName === newValue
              );
              if (selectedShipper) {
                setShipperId(selectedShipper.ShipperLinerId);
              }
            }
          }}
          onInputChange={(event, newInputValue) => {
            if (event?.type === 'change') {
              setFieldValue('shipper', newInputValue);
            }
          }}
          freeSolo
          // disabled={shipperPriceData.length === 0}
          disabled
          noOptionsText={shipperPriceData.length === 0 ? "Select country & type" : "No shippers"}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Shipper"
              placeholder="Select shipper"
              size="small"
            />
          )}
        /> */}
         <TextField
                                fullWidth
                                size="small"
                                label="Shipper"
                                name="shipper"
                                value={values.shipper || ''}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled
                              />
      </FormControl>
    </Grid>
                  <Grid item md={values.shipMentType !== 'SCSL' ? 3 : 4} xs={12}>
                    <FormControl fullWidth size="small">
                      <Autocomplete
                        options={countryList || []}
                        getOptionLabel={(country) => country.CountryName || ''}
                        renderOption={(props, country) => (
                          <li {...props} key={country.CountryId}>
                            {country.CountryName}
                          </li>
                        )}
                        isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                        value={countryList.find((country) => country.CountryId === values.senderCountry) || null}
                        name="senderCountry"
                        onChange={(event, value) => {
                          if (value) {
                            setsenderCountryErr(false);
                            setFieldValue('senderCountry', value.CountryId);
                            handleCountryChangeSender(value, handleChange);
                          } else {
                            setFieldValue('senderCountry', '');
                          }
                        }}
                        onBlur={() => setFieldTouched('senderCountry', true)}
                        size="small"
                        required
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            label="Sender Country"
                            value={values.senderCountry ? values.senderCountry : ''}
                            error={Boolean(touched.senderCountry && errors.senderCountry)}
                            helperText={touched.senderCountry && errors.senderCountry ? errors.senderCountry : ''}
                            FormHelperTextProps={{ style: { color: 'red' } }}
                          />
                        )}
                        noOptionsText="No country available"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={values.shipMentType !== 'SCSL' ? 3 : 4} xs={12}>
                    <FormControl fullWidth size="small">
                      <Autocomplete
                        options={countryList || []} // Options for the Autocomplete
                        getOptionLabel={(country) => country.CountryName || ''} // Display country name
                        renderOption={(props, country) => (
                          <li {...props} key={country.CountryId}>
                            {country.CountryName}
                          </li>
                        )}
                        isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId} // Compare options
                        value={countryList.find((country) => country.CountryId === values.receiverCountry) || null}
                        name="receiverCountry"
                        onChange={(event, value) => {
                          if (value) {
                            setreceiverCountryErr(false);
                            setFieldValue('receiverCountry', value.CountryId);
                            setReceiverCountryId(value.CountryId);
                            handleCountryChangereceiver(value, handleChange);
                            if (values.shipMentType !== 'SCSL') {
                              GetCourierShipperPrice(boxDetails);
                            } else {
                              // GetCargoShipperPrice(boxDetails)
                              // GetCargoShipperPrice1(null, value.CountryId, null, boxDetails);
                              GetCargoNewShipperPrice(values.CountryId, boxDetails);
                            }
                          } else {
                            setFieldValue('receiverCountry', '');
                          }
                        }}
                        onBlur={() => setFieldTouched('receiverCountry', true)}
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            label="Receiver Country"
                            value={values.receiverCountry ? values.receiverCountry : ''}
                            error={Boolean(touched.receiverCountry && errors.receiverCountry)}
                            helperText={touched.receiverCountry && errors.receiverCountry ? errors.receiverCountry : ''}
                            FormHelperTextProps={{ style: { color: 'red' } }}
                          />
                        )}
                        noOptionsText="No country available"
                      />
                    </FormControl>
                  </Grid>

                  {values.shipMentType !== 'SCSL' &&
                    <>

                      <Grid item md={2} xs={12}>
                        <FormControl fullWidth size="small" required>
                          <InputLabel>Document Type</InputLabel>
                          <Select
                            value={values.docType || ''}
                            name="docType"
                            size="small"
                            label="Document Type"
                            // onChange={handleChange}
                            onChange={async (event) => {
                              handleChange(event);
                              const data = event.target.value
                              setDocumentType(data)
                              setInitialValue(() => ({ ...values, docType: data }))
                              GetCourierShipperPrice(boxDetails, values.receiverCountry, data);
                            }}
                            onBlur={handleBlur}
                            error={touched.docType && !!errors.docType}
                            required
                          >
                            {DocTypes.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {touched.docType && errors.docType && (
                            <Typography variant="caption" color="error" className="shake-helper-text" margin="4px 0 0 14px">
                              {errors.docType}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item md={!bookingStarted ? 2 : values.shipMentType !== 'SCSL' ? 1 : 3} xs={12}>
                        <FormControl fullWidth size="small" required>
                          <InputLabel>Dimension</InputLabel>
                          <Select
                            value={values.dimensionType || ''}
                            name="dimensionType"
                            size="small"
                            label="Dimension Type"
                            onChange={async (event) => {
                              handleChange(event);
                              const data = event.target.value
                              setInitialValue(() => ({ ...values, dimensionType: data }))

                              if (boxDetails.length > 0) {
                                const updatedBoxes = boxDetails.map((box) => {
                                  const rawCubicWeight =
                                    data === 'CM'
                                      ? (box.height * box.width * box.length) / 5000
                                      : (box.height * box.width * box.length) / 1925;
                                  return {
                                    ...box,
                                    cubicWeight: parseFloat(rawCubicWeight.toFixed(2)),
                                  };
                                });
                                setBoxDetails(updatedBoxes);
                                GetCourierShipperPrice(updatedBoxes);
                              }
                            }}
                            onBlur={handleBlur}
                            error={touched.dimensionType && !!errors.dimensionType}
                            required
                          >
                            {DimensionType.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {touched.dimensionType && errors.dimensionType && (
                            <Typography variant="caption" color="error" className="shake-helper-text" margin="4px 0 0 14px">
                              {errors.dimensionType}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                    </>
                  }
                  <Grid item md={values.shipMentType !== 'SCSL' ? 2 : 3} xs={12}>
                    <TextField
                      fullWidth
                      size="small"
                      label="No of Boxes"
                      type="text"
                      name="NofoBoxes"
                      disabled
                      // disabled={bookingStarted}
                      onBlur={handleBlur}
                      error={touched.NofoBoxes && errors.NofoBoxes}
                      helperText={touched.NofoBoxes && errors.NofoBoxes ? errors.NofoBoxes : ''}
                      FormHelperTextProps={{ style: { color: 'red' } }}
                      value={values.NofoBoxes}
                      required
                      onChange={(e) => {
                        handleChange(e);
                        const noOfBoxes = parseInt(e.target.value, 10);

                        // Dynamically update the lengths in boxDetails if valid input
                        if (!Number.isNaN(Number(noOfBoxes)) && noOfBoxes > 0) {
                          const updatedBoxDetails = values.boxDetails.map((box, index) => ({
                            ...box,
                            length: noOfBoxes + index, // Example logic: Update length dynamically
                          }));

                          // Update Formik's state
                          setFieldValue('boxDetails', updatedBoxDetails);
                        }
                      }}
                    />
                  </Grid>

                  {bookingStarted && (
                    <Grid item md={1} xs={12}>
                      <Stack direction="row" justifyContent="center" sx={{ width: '100%' }}>
                        <Button
                          variant={'outlined'}
                          color={'error'}
                          size={'medium'}
                          sx={{ boxShadow: 1 }}
                          type={'button'}
                          onClick={async () => {
                            if (bookingStarted) {
                              setResetOpenDialog(true);
                            } else {
                              const formErrors = await validateForm();
                              if (Object.keys(formErrors).length === 0) {
                                handleBoxCountChange(values.NofoBoxes, values.shipMentType);
                                setBookingStarted(true);
                              }
                            }
                          }}
                          fullWidth={bookingStarted}
                        >
                          {'Reset'}
                        </Button>
                      </Stack>
                    </Grid>
                  )}
                  {bookingStarted && (
                    <>
                     
                      {/* )} */}
                      <Grid item md={12} xs={12}>
                        <Divider sx={{ my: 2 }} variant="middle">
                          <Chip label="Shipment Details" size="small" color="info" variant="outlined" />
                        </Divider>
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Grid container spacing={2} rowSpacing={4} columnSpacing={4} pl={2}>
                          <Grid item xs={12}>
                            <Stack
                              direction="column"
                              alignItems="right"
                              justifyContent="right"
                              spacing={1}
                              sx={{ p: 0, m: 0 }}
                            >
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={sameAsSender}
                                    onChange={(event) => {
                                      handleSamesAsAddress(event, setFieldValue, values);
                                    }}
                                    name="sameAsAddress"
                                    color="primary"
                                  />
                                }
                                label="Same as Customer"
                                sx={{
                                  marginTop: 0,
                                  '& .MuiTypography-root': { fontSize: '0.875rem', margin: 0 },
                                }}
                              />
                            </Stack>
                          </Grid>
                          {/* sender details */}
                          <Grid item md={6} xs={12}>
                            <Grid
                              container
                              spacing={2}
                              rowSpacing={2}
                              columnSpacing={2}
                              component={Paper}
                              p={2}
                              pt={0}
                              pl={0}
                              pr={2}
                              elevation={3}
                              sx={{
                                bgcolor: 'inherit',
                                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                              }}
                            >
                              <Grid item md={12} xs={12}>
                                <Divider sx={{ mb: 0 }} variant="fullWidth">
                                  <Chip label="Sender Details" size="small" variant="outlined" />
                                </Divider>
                              </Grid>
                              <Grid item md={12} xs={12}>
                                <TextField
                                  required
                                  fullWidth
                                  size="small"
                                  label="Name"
                                  type="text"
                                  name="senderName"
                                  inputRef={el => { fieldRefs.current.senderName = el; }}
                                  onBlur={handleBlur}
                                  error={touched.senderName && !!errors.senderName}
                                  helperText={touched.senderName && errors.senderName ? errors.senderName : ''}
                                  value={values.senderName}
                                  onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <TextField
                                  fullWidth
                                  required
                                  size="small"
                                  label="Contact No"
                                  type="text"
                                  name="senderPhone"
                                  inputRef={el => { fieldRefs.current.senderPhone = el; }}
                                  onBlur={handleBlur}
                                  error={touched.senderPhone && !!errors.senderPhone}
                                  helperText={touched.senderPhone && errors.senderPhone ? errors.senderPhone : ''}
                                  value={values.senderPhone}
                                  onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                    handleChange({ target: { name: 'senderPhone', value: numericValue } }); // Manually trigger Formik's handleChange
                                  }}
                                // onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  label="Alternative Contact No"
                                  type="text"
                                  name="senderAlterPhone"
                                  onBlur={handleBlur}
                                  error={touched.senderAlterPhone && !!errors.senderAlterPhone}
                                  helperText={touched.senderAlterPhone && errors.senderAlterPhone ? errors.senderAlterPhone : ''}
                                  value={values.senderAlterPhone}
                                  onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                    handleChange({ target: { name: 'senderAlterPhone', value: numericValue } }); // Manually trigger Formik's handleChange
                                  }}
                                // onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={12} xs={12}>
                                <TextField
                                  fullWidth
                                  required
                                  size="small"
                                  label="Email"
                                  type="email"
                                  name="senderEmail"
                                  inputRef={el => { fieldRefs.current.senderEmail = el; }}
                                  onBlur={handleBlur}
                                  error={touched.senderEmail && !!errors.senderEmail}
                                  helperText={touched.senderEmail && errors.senderEmail ? errors.senderEmail : ''}
                                  value={values.senderEmail}
                                  onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <TextField
                                  multiline
                                  required
                                  rows={3}
                                  fullWidth
                                  size="small"
                                  label="Address 1"
                                  name="senderAddr1"
                                  inputRef={el => { fieldRefs.current.senderAddr1 = el; }}
                                  onBlur={handleBlur}
                                  error={touched.senderAddr1 && !!errors.senderAddr1}
                                  helperText={touched.senderAddr1 && errors.senderAddr1 ? errors.senderAddr1 : ''}
                                  value={values.senderAddr1}
                                  onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <TextField
                                  multiline
                                  rows={3}
                                  fullWidth
                                  size="small"
                                  label="Address 2"
                                  name="senderAddr2"
                                  onBlur={handleBlur}
                                  error={touched.senderAddr2 && !!errors.senderAddr2}
                                  helperText={touched.senderAddr2 && errors.senderAddr2 ? errors.senderAddr2 : ''}
                                  value={values.senderAddr2}
                                  onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <TextField
                                  multiline
                                  rows={3}
                                  fullWidth
                                  size="small"
                                  label="Address 3"
                                  name="senderAddr3"
                                  onBlur={handleBlur}
                                  error={touched.senderAddr3 && !!errors.senderAddr3}
                                  helperText={touched.senderAddr3 && errors.senderAddr3 ? errors.senderAddr3 : ''}
                                  value={values.senderAddr3}
                                  onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <FormControl fullWidth size="small">
                                  {/* <InputLabel>Sender Country</InputLabel> */}
                                  {/* <Select
                                    value={values.country || ''}
                                    name="country"
                                    size="small"
                                    label="senderCountry"
                                    onChange={(e) => {
                                      handleCountryChangeSender(e, handleChange);
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.senderCountry && !!errors.senderCountry}
                                  >
                                    {countryList.map((country) => (
                                      <MenuItem key={country.CountryId} value={country.CountryId}>
                                        {country.CountryName}
                                      </MenuItem>
                                    ))}
                                    {!countryList.length && <MenuItem disabled>No country available</MenuItem>}
                                  </Select>
                                  {touched.senderCountry && errors.senderCountry && (
                                    <Typography
                                      variant="caption"
                                      color="error"
                                      className="shake-helper-text"
                                      margin="4px 0 0 14px"
                                    >
                                      {errors.senderCountry}
                                    </Typography>
                                  )} */}
                                  <Autocomplete
                                    options={countryList || []}
                                    getOptionLabel={(country) => country.CountryName || ''}
                                    renderOption={(props, country) => (
                                      <li {...props} key={country.CountryId}>
                                        {country.CountryName}
                                      </li>
                                    )}
                                    isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                                    value={
                                      countryList.find((country) => country.CountryId === values.senderCountry) ||
                                      null
                                    }
                                    name="senderCountry"
                                    onChange={(event, value) => {
                                      if (value) {
                                        setFieldValue('senderCountry', value.CountryId);
                                        handleCountryChangeSender(value, handleChange);
                                      } else {
                                        setFieldValue('senderCountry', '');
                                      }
                                    }}
                                    onBlur={() => setFieldTouched('senderCountry', true)}
                                    size="small"
                                    disabled
                                    renderInput={(params) => (
                                      <TextField
                                        required
                                        {...params}
                                        label="Sender Country"
                                        value={values.senderCountry ? values.senderCountry : ''}
                                        // error={touched.senderCountry && !!errors.senderCountry}
                                        // helperText={touched.senderCountry && errors.senderCountry}
                                        helperText={senderCountryErr ? 'Sender Country is required' : ''}
                                        FormHelperTextProps={{
                                          style: { color: 'red' },
                                        }}
                                      />
                                    )}
                                    noOptionsText="No country available"
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <FormControl fullWidth size="small">
                                  {/* <InputLabel>State</InputLabel> */}
                                  {/* <Select
                                    value={values.senderState || ''}
                                    name="state"
                                    size="small"
                                    label="State"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.senderState && !!errors.senderState}
                                  >
                                    {senderStateList.map((state) => (
                                      <MenuItem key={state.StateId} value={state.StateId}>
                                        {state.StateName}
                                      </MenuItem>
                                    ))}
                                    {!senderStateList.length && <MenuItem disabled>No state available</MenuItem>}
                                  </Select>
                                  {touched.senderState && errors.senderState && (
                                    <Typography
                                      variant="caption"
                                      color="error"
                                      className="shake-helper-text"
                                      margin="4px 0 0 14px"
                                    >
                                      {errors.senderState}
                                    </Typography>
                                  )} */}
                                  <Autocomplete
                                    options={senderStateList || []} // Options for the Autocomplete
                                    getOptionLabel={(state) => state.StateName || ''}
                                    renderOption={(props, state) => (
                                      <li {...props} key={state.StateId}>
                                        {state.StateName}
                                      </li>
                                    )}
                                    isOptionEqualToValue={(option, value) => option?.StateId === value?.StateId}
                                    value={
                                      senderStateList.find((state) => state.StateId === values.senderState) || null
                                    }
                                    name="senderState"
                                    onChange={(event, value) => {
                                      if (value) {
                                        setFieldValue('senderState', value.StateId);
                                      } else {
                                        setFieldValue('senderState', '');
                                      }
                                    }}
                                    onBlur={() => setFieldTouched('senderState', true)}
                                    size="small"
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Sender Province/State"
                                        value={values.senderState ? values.senderState : ''}
                                      // error={touched.senderState && !!errors.senderState}
                                      // helperText={touched.senderState && errors.senderState}
                                      />
                                    )}
                                    noOptionsText="No Province/State available"
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <TextField
                                  fullWidth
                                  required
                                  size="small"
                                  label="City"
                                  type="text"
                                  name="senderCity"
                                  inputRef={el => { fieldRefs.current.senderCity = el; }}
                                  onBlur={handleBlur}
                                  error={touched.senderCity && !!errors.senderCity}
                                  helperText={touched.senderCity && errors.senderCity ? errors.senderCity : ''}
                                  value={values.senderCity}
                                  onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <TextField
                                  fullWidth
                                  required
                                  size="small"
                                  label="Postal Code"
                                  type="text"
                                  name="senderPincode"
                                  inputRef={el => { fieldRefs.current.senderPincode = el; }}
                                  onBlur={handleBlur}
                                  error={touched.senderPincode && !!errors.senderPincode}
                                  helperText={
                                    touched.senderPincode && errors.senderPincode ? errors.senderPincode : ''
                                  }
                                  value={values.senderPincode}
                                  onChange={handleChange}
                                />
                              </Grid>
                            </Grid>
                          </Grid>

                          {/* Receiver details */}
                          <Grid item md={6} xs={12}>
                            <Grid
                              container
                              spacing={2}
                              rowSpacing={2}
                              columnSpacing={2}
                              component={Paper}
                              p={2}
                              pt={0}
                              pl={0}
                              pr={2}
                              elevation={3}
                              sx={{
                                bgcolor: 'inherit',
                                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                              }}
                            >
                              <Grid item md={12} xs={12}>
                                <Divider sx={{ mb: 0 }} variant="fullWidth">
                                  <Chip label="Receiver Details" size="small" variant="outlined" />
                                </Divider>
                              </Grid>
                              {/* <Grid item md={12} xs={12}>
                                <TextField
                                  fullWidth
                                  required
                                  size="small"
                                  label="Name"
                                  type="text"
                                  name="receiverName"
                                  onBlur={handleBlur}
                                  error={touched.receiverName && !!errors.receiverName}
                                  helperText={touched.receiverName && errors.receiverName ? errors.receiverName : ''}
                                  value={values.receiverName}
                                  onChange={handleChange}
                                />
                              </Grid> */}
                              <Grid item md={12} xs={12}>
                                <FormControl fullWidth size="small">
                                  <Autocomplete
                                    options={receiverList || []} // Options for the Autocomplete
                                    getOptionLabel={(receiver) => {
                                      if (!receiver) return ''; // Handle null/undefined
                                      if (typeof receiver === 'string') return receiver; // Handle free text input
                                      return `${receiver.receiver_Name}`;
                                    }}
                                    filterOptions={(options, state) => {
                                      const inputValue = state.inputValue.toLowerCase();
                                      return options.filter(option =>
                                        option.receiver_Name.toLowerCase().includes(inputValue) ||
                                        (option.receiver_ContactNo && option.receiver_ContactNo.toString().toLowerCase().includes(inputValue))
                                      );
                                    }}
                                    renderOption={(props, receiver) => (
                                      <li {...props} key={receiver.receiver_Id}>
                                        <div>
                                          <strong>{receiver.receiver_Name}</strong>
                                          <div style={{ fontSize: '0.8rem', color: '#666' }}>
                                            {receiver.receiver_ContactNo}
                                          </div>
                                        </div>
                                      </li>
                                    )}
                                    isOptionEqualToValue={(option, value) => {
                                      if (!option || !value) return false;
                                      if (typeof value === 'string') return option.receiver_Name === value;
                                      return option.receiver_Id === value.receiver_Id;
                                    }}
                                    value={
                                      // Handle both object selection and free text input
                                      values.receiverId
                                        ? receiverList.find(r => r.receiver_Id === values.receiverId) || values.receiverName || null
                                        : values.receiverName || null
                                    }
                                    name="receiverName"
                                    onChange={(event, value) => {
                                      if (value && typeof value === 'object') {
                                        // Selected from dropdown
                                        setFieldValue('receiverName', value.receiver_Name);
                                        setFieldValue('receiverId', value.receiver_Id);
                                        setFieldValue('receiverAddr1', value.receiver_Address1);
                                        setFieldValue('receiverAddr2', value.receiver_Address2);
                                        setFieldValue('receiverAddr3', value.receiver_Address3);
                                        setFieldValue('receiverCity', value.receiver_City);
                                        setFieldValue('receiverState', value.receiver_Stateid);
                                        setFieldValue('receiverPincode', value.receiver_Pincode);
                                        setFieldValue('receiverPhone', value.receiver_ContactNo);
                                        setFieldValue('receiverAlterPhone', value.receiver_AlterContactNo);
                                        setFieldValue('receiverEmail', value.receiver_EmailId);
                                         setFieldValue('idCardType',value.Sender_Idcard_Type);
                                        setFieldValue('IdCardNo',value.Sender_Idcard_No);
                                        setFieldValue('RecidCardType',value.Receiver_Idcard_Type);
                                        setFieldValue('RecIdCardNo',value.Receiver_Idcard_No);
                                    if(values.shipMentType === 'SCSL'){setFieldValue('nic', value.Nic_No);} 
                                    const buildImageUrl = (imgPath) => {
                                if (!imgPath) return '';
                                if (imgPath.startsWith('http') || imgPath.startsWith('//')) return imgPath;
                                const origin = sessionStorage.getItem('Origin');
                                const base = origin === 'IN' ? axios.defaults.inImageURL 
                                : origin === 'UK' ? axios.defaults.ukImageURL : axios.defaults.slImageURL;
                                return `${base}/${imgPath}`;
                              };
                              let senderImg;
                              let receiverImg;
                             if(values.shipMentType === 'SCSL') {
                               senderImg = `CG_FMT${value.Sender_Idcard_No}-${getIdCardNameById(value.Sender_Idcard_Type)}.jpg`;
                               receiverImg = `CG_BMT${value.Receiver_Idcard_No}-${getIdCardNameById(value.Receiver_Idcard_Type)}.jpg`;
                               setSendPreviewBtn(true)
                                setReceivPreviewBtn(true)
                             } else {
                               senderImg = `MT${value.Sender_Idcard_No}-${getIdCardNameById(value.Sender_Idcard_Type)}.jpg`;
                               receiverImg = `BMT${value.Receiver_Idcard_No}-${getIdCardNameById(value.Receiver_Idcard_Type)}.jpg`;
                               setSendPreviewBtn(true)
                                setReceivPreviewBtn(true)
                             }
                              

                              setSenderImagePreview(buildImageUrl(senderImg));
                              setReceiverImagePreview(buildImageUrl(receiverImg));
                              setSenderImageFile(senderImg || null);
                              setReceiverImageFile(receiverImg || null);
                                      } else {
                                        // Free text input or cleared
                                        setFieldValue('receiverName', value || '');
                                        setFieldValue('receiverId', '');
                                      }
                                    }}
                                    onInputChange={(event, newInputValue, reason) => {
                                      if (reason === 'input' || reason === 'clear') {
                                        setFieldValue('receiverName', newInputValue);
                                      }
                                    }}
                                    onBlur={(event) => {
                                      setFieldTouched('receiverName', true);
                                      // Handle case where user typed but didn't select
                                      const inputValue = event.target.value;
                                      if (inputValue && !values.receiverId) {
                                        const matchedOption = receiverList.find(option =>
                                          `${option.receiver_Name} - ${option.receiver_ContactNo}` === inputValue
                                        );
                                        if (matchedOption) {
                                          setFieldValue('receiverName', matchedOption.receiver_Name);
                                          setFieldValue('receiverId', matchedOption.receiver_Id);
                                        }
                                      }
                                    }}
                                    size="small"
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Name"
                                        inputRef={el => { fieldRefs.current.receiverName = el; }}
                                        value={values.receiverName ? values.receiverName : ''}
                                        error={touched.receiverName && Boolean(errors.receiverName)}
                                        helperText={touched.receiverName && errors.receiverName}
                                        FormHelperTextProps={{
                                          style: { color: 'red' },
                                        }}
                                        required
                                      />
                                    )}
                                    noOptionsText="No Receiver available"
                                    freeSolo
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <TextField
                                  fullWidth
                                  required
                                  size="small"
                                  label="Contact No"
                                  type="number"
                                  name="receiverPhone"
                                  inputRef={el => { fieldRefs.current.receiverPhone = el; }}
                                  onBlur={handleBlur}
                                  error={touched.receiverPhone && !!errors.receiverPhone}
                                  helperText={
                                    touched.receiverPhone && errors.receiverPhone ? errors.receiverPhone : ''
                                  }
                                  value={values.receiverPhone}
                                  onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                    handleChange({ target: { name: 'receiverPhone', value: numericValue } }); // Manually trigger Formik's handleChange
                                  }}
                                // onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  label="Alternative Contact No"
                                  type="text"
                                  name="receiverAlterPhone"
                                  onBlur={handleBlur}
                                  error={touched.receiverAlterPhone && !!errors.receiverAlterPhone}
                                  helperText={touched.receiverAlterPhone && errors.receiverAlterPhone ? errors.receiverAlterPhone : ''}
                                  value={values.receiverAlterPhone}
                                  onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                    handleChange({ target: { name: 'receiverAlterPhone', value: numericValue } }); // Manually trigger Formik's handleChange
                                  }}
                                // onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={12} xs={12}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  label="Email"
                                  type="email"
                                  name="receiverEmail"
                                  onBlur={handleBlur}
                                  error={touched.receiverEmail && !!errors.receiverEmail}
                                  helperText={
                                    touched.receiverEmail && errors.receiverEmail ? errors.receiverEmail : ''
                                  }
                                  value={values.receiverEmail}
                                  onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <TextField
                                  required
                                  multiline
                                  rows={3}
                                  fullWidth
                                  size="small"
                                  label="Address 1"
                                  name="receiverAddr1"
                                  inputRef={el => { fieldRefs.current.receiverAddr1 = el; }}
                                  onBlur={handleBlur}
                                  error={touched.receiverAddr1 && !!errors.receiverAddr1}
                                  helperText={
                                    touched.receiverAddr1 && errors.receiverAddr1 ? errors.receiverAddr1 : ''
                                  }
                                  value={values.receiverAddr1}
                                  onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <TextField
                                  multiline
                                  rows={3}
                                  fullWidth
                                  size="small"
                                  label="Address 2"
                                  name="receiverAddr2"
                                  onBlur={handleBlur}
                                  error={touched.receiverAddr2 && !!errors.receiverAddr2}
                                  helperText={
                                    touched.receiverAddr2 && errors.receiverAddr2 ? errors.receiverAddr2 : ''
                                  }
                                  value={values.receiverAddr2}
                                  onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={4} xs={12}>
                                <TextField
                                  multiline
                                  rows={3}
                                  fullWidth
                                  size="small"
                                  label="Address 3"
                                  name="receiverAddr3"
                                  onBlur={handleBlur}
                                  error={touched.receiverAddr3 && !!errors.receiverAddr3}
                                  helperText={
                                    touched.receiverAddr3 && errors.receiverAddr3 ? errors.receiverAddr3 : ''
                                  }
                                  value={values.receiverAddr3}
                                  onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <FormControl fullWidth size="small">
                                  {/* <InputLabel>Country</InputLabel>
                                  <Select
                                    value={values.country || ''}
                                    name="country"
                                    size="small"
                                    label="receiverCountry"
                                    onChange={(e) => {
                                      handleCountryChangereceiver(e, handleChange);
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.receiverCountry && !!errors.receiverCountry}
                                  >
                                    {countryList.map((country) => (
                                      <MenuItem key={country.CountryId} value={country.CountryId}>
                                        {country.CountryName}
                                      </MenuItem>
                                    ))}
                                    {!countryList.length && <MenuItem disabled>No country available</MenuItem>}
                                  </Select>
                                  {touched.receiverCountry && errors.receiverCountry && (
                                    <Typography
                                      variant="caption"
                                      color="error"
                                      className="shake-helper-text"
                                      margin="4px 0 0 14px"
                                    >
                                      {errors.receiverCountry}
                                    </Typography>
                                  )} */}
                                  <Autocomplete
                                    options={countryList || []} // Options for the Autocomplete
                                    getOptionLabel={(country) => country.CountryName || ''} // Display country name
                                    renderOption={(props, country) => (
                                      <li {...props} key={country.CountryId}>
                                        {country.CountryName}
                                      </li>
                                    )}
                                    isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId} // Compare options
                                    value={
                                      countryList.find((country) => country.CountryId === values.receiverCountry) ||
                                      null
                                    }
                                    name="receiverCountry"
                                    onChange={(event, value) => {
                                      if (value) {
                                        setreceiverCountryErr(false);
                                        setFieldValue('receiverCountry', value.CountryId);
                                        setReceiverCountryId(value.CountryId);
                                        handleCountryChangereceiver(value, handleChange);
                                        // GetShipperPrice(boxDetails);
                                      } else {
                                        setFieldValue('receiverCountry', '');
                                      }
                                    }}
                                    onBlur={() => setFieldTouched('receiverCountry', true)}
                                    size="small"
                                    disabled
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        required
                                        label="Receiver Country"
                                        value={values.receiverCountry ? values.receiverCountry : ''}
                                        // error={touched.receiverCountry && !!errors.receiverCountry}
                                        // helperText={touched.receiverCountry && errors.receiverCountry}
                                        helperText={receiverCountryErr ? 'Receiver Country is required' : ''}
                                        FormHelperTextProps={{
                                          style: { color: 'red' },
                                        }}
                                      />
                                    )}
                                    noOptionsText="No country available"
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <FormControl fullWidth size="small">
                                  {/* <InputLabel>State</InputLabel>
                                  <Select
                                    value={values.receiverState || ''}
                                    name="state"
                                    size="small"
                                    label="State"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.receiverState && !!errors.receiverState}
                                  >
                                    {receiverStateList.map((state) => (
                                      <MenuItem key={state.StateId} value={state.StateId}>
                                        {state.StateName}
                                      </MenuItem>
                                    ))}
                                    {!receiverStateList.length && <MenuItem disabled>No state available</MenuItem>}
                                  </Select>
                                  {touched.receiverState && errors.receiverState && (
                                    <Typography
                                      variant="caption"
                                      color="error"
                                      className="shake-helper-text"
                                      margin="4px 0 0 14px"
                                    >
                                      {errors.receiverState}
                                    </Typography>
                                  )} */}
                                  <Autocomplete
                                    options={receiverStateList || []} // Options for the Autocomplete
                                    getOptionLabel={(state) => state.StateName || ''}
                                    renderOption={(props, state) => (
                                      <li {...props} key={state.StateId}>
                                        {state.StateName}
                                      </li>
                                    )}
                                    isOptionEqualToValue={(option, value) => option?.StateId === value?.StateId}
                                    value={
                                      receiverStateList.find((state) => state.StateId === values.receiverState) ||
                                      null
                                    }
                                    name="receiverState"
                                    onChange={(event, value) => {
                                      if (value) {
                                        setFieldValue('receiverState', value.StateId);
                                      } else {
                                        setFieldValue('receiverState', '');
                                      }
                                    }}
                                    onBlur={() => setFieldTouched('receiverState', true)}
                                    size="small"
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Receiver Province/State"
                                        value={values.receiverState ? values.receiverState : ''}
                                      // error={touched.receiverState && !!errors.receiverState}
                                      // helperText={touched.receiverState && errors.receiverState}
                                      />
                                    )}
                                    noOptionsText="No Province/State available"
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <TextField
                                  fullWidth
                                  required
                                  size="small"
                                  label="City"
                                  type="text"
                                  name="receiverCity"
                                  inputRef={el => { fieldRefs.current.receiverCity = el; }}
                                  onBlur={handleBlur}
                                  error={touched.receiverCity && !!errors.receiverCity}
                                  helperText={touched.receiverCity && errors.receiverCity ? errors.receiverCity : ''}
                                  value={values.receiverCity}
                                  onChange={handleChange}
                                />
                              </Grid>
                              <Grid item md={6} xs={12}>
                                <TextField
                                  fullWidth
                                  required
                                  size="small"
                                  label="Postal Code"
                                  type="text"
                                  name="receiverPincode"
                                  inputRef={el => { fieldRefs.current.receiverPincode = el; }}
                                  onBlur={handleBlur}
                                  error={touched.receiverPincode && !!errors.receiverPincode}
                                  helperText={
                                    touched.receiverPincode && errors.receiverPincode ? errors.receiverPincode : ''
                                  }
                                  value={values.receiverPincode}
                                  onChange={handleChange}
                                />
                              </Grid>
                             {values.shipMentType === 'SCSL'  && <Grid item md={6} xs={12}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  label="NIC"
                                  type="text"
                                  name="nic"
                                  inputRef={el => { fieldRefs.current.nic = el; }}
                                  onBlur={handleBlur}
                                  value={values.nic}
                                  onChange={(e) => {
                                    // Filter to allow only alphanumeric characters and spaces
                                    const alphanumericValue = e.target.value.replace(/[^A-Za-z0-9 ]/g, '');
                                    
                                    // Create a synthetic event with the filtered value
                                    const syntheticEvent = {
                                      ...e,
                                      target: {
                                        ...e.target,
                                        name: 'nic',
                                        value: alphanumericValue
                                      }
                                    };
                                    
                                    // Call the original handleChange with filtered value
                                    handleChange(syntheticEvent);
                                  }}
                                  inputProps={{
                                    maxLength: 30,
                                    pattern: "[A-Za-z0-9]*" // HTML5 pattern validation
                                  }}
                                                                // disabled={isDisabled}
                                  />
                                </Grid>}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                                     {/* ID Card Details Section */}
               <Grid item xs={12} m={0}>
                 <Grid
                   container
                   spacing={2}
                   rowSpacing={2}
                   columnSpacing={2}
                   component={Paper}
                   p={1}
                   m={0}
                   elevation={3}
                   sx={{
                     width: '100%',
                     bgcolor: 'inherit',
                     boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                   }}
                 >
                   {/* Main container for all three sections in one row */}
                   <Grid container spacing={2} sx={{ mt: 0, p: 0, width: '100%' }}>
                     {/* Sender Section - Left Column */}
                     <Grid item md={4} xs={12}>
                       <Stack direction="column"  sx={{ height: '100%' }}>
                         {/* Sender Image */}
                         <Stack
                           direction="row"
                           alignItems="center"
                           spacing={1}
                           border={1}
                           borderRadius={1}
                           borderColor="#e0e0e0"
                           p={1}
                           justifyContent="center"
                           sx={{
                             height: '100%',
                             bgcolor: 'background.paper',
                             minHeight: { xs: 'auto', md: '180px' }
                           }}
                         >
                           <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                             <Box sx={{ textAlign: 'center', width: '100%' }}>
                               <label htmlFor="fileInputSender">
                                 <img
                                   src={
                                     senderImagePreview || imagepreview
                                     // (senderImageFile === null ||
                                     //   senderImageFile === '' ||
                                     //   !senderImageFile
                                     //   ? imagepreview
                                     //   : NoimageFound)
                                   }
                                   alt="No Img"
                                   className={classes.chooseFileButton}
                                   style={{
                                     width: '100%',
                                     maxWidth: '250px',
                                     height: '150px',
                                     objectFit: 'contain',
                                   }}
                                    onError={(e) => {
                                   e.target.onerror = null; // Prevent infinite loop
                                   e.target.src = imagepreview;
                                   setSendPreviewBtn(false)
                                 }}
                                 />
                                 <input
                                   className={classes.fileInput}
                                   id="fileInputSender"
                                   type="file"
                                   accept="image/jpeg"
                                   name="IDcardFile"
                                   onClick={(event)=>{
                                     if ((!values.IdCardNo || values.IdCardNo.trim() === '') || values.IdCardNo.trim() === '0') {
                                     openSnackBar('Please enter ID Card No before uploading image', 'error');
                                     event.preventDefault()
                                     event.stopPropagation()
                                     return;
                                   }
                                   }}
                                   onChange={(event) => {
                                     handleIdFileChange(event, 'sender', values);
                                     handleChange(event);
                                   }}
                                   
                                   style={{ display: 'none' }}
                                  //  disabled={isDisabled}
                                 />
                               </label>
                               {((senderImagePreview || senderImageFile ) && (sendPreviewBtn)) && (
                                 <Button
                                   onClick={() => handleOpenDialogPreview('sender')}
                                   variant="contained"
                                   color="primary"
                                   size="small"
                                   sx={{
                                     boxShadow: 1,
                                     mt: 1,
                                     width: '100%',
                                     maxWidth: '250px',
                                     mx: 'auto'
                                   }}
                                 >
                                   Preview
                                 </Button>
                               )}
                             </Box>
                           </Stack>
                         </Stack>
               
                         {/* Sender ID Card Type and Number */}
                         <Grid container spacing={2} sx={{ mt: 0, p: 0 }}>
                           <Grid item xs={12} md={12}>
                             <FormControl fullWidth size="small">
                               <InputLabel>ID Card Type</InputLabel>
                               <Select
                                 value={values.idCardType || ''}
                                 name="idCardType"
                                 size="small"
                                 label="ID Card Type"
                                onChange={(e) => { 
                   const newValue = e.target.value;
                   
                   // Check if in edit mode and value has changed from initial
                   if (initialValue.idCardType && newValue !== initialValue.idCardType) {
                     // If there's an existing image, show confirmation dialog
                     if (senderImageFile || senderImagePreview) {
                       setPendingIdCardChanges(prev => ({ 
                         ...prev, 
                         sender: { newValue, field: 'idCardType', isTypeChange: true } 
                       }));
                       setShowIdCardChangeDialog(prev => ({ ...prev, sender: true }));
                       return; // Don't update the field yet
                     }
                   }
                   
                   // Update the field immediately if no image or not in edit mode
                   setFieldValue('IdCardNo', '');
                   setSenderImageFile(null);
                   setSenderImagePreview('');
                   setFieldValue('idCardType', newValue || '');
                   const senderInput = document.getElementById('fileInputSender');
                   if (senderInput) {
                     senderInput.value = '';
                   }
                 }}
                                 onBlur={handleBlur}
                                 error={touched.idCardType && !!errors.idCardType}
                                //  disabled={isDisabled}
                               >
                                 {idCardTypes.map((idCard) => (
                                   <MenuItem key={idCard.id} value={idCard.id}>
                                     {idCard.name}
                                   </MenuItem>
                                 ))}
                               </Select>
                             </FormControl>
                           </Grid>
               
                           <Grid item xs={12} md={12}>
                             <TextField
                               fullWidth
                               size="small"
                               label={
                                 <span>
                                   ID Card No
                                   {values.idCardType && values.idCardType !== '' && values.idCardType !== '0' ?
                                     <span style={{ color: 'red', marginLeft: '2px' }}>*</span> : null
                                   }
                                 </span>
                               }
                               type="text"
                               name="IdCardNo"
                               inputRef={el => { fieldRefs.current.IdCardNo = el; }}
                               onBlur={handleBlur}
                               error={touched.IdCardNo && !!errors.IdCardNo}
                               helperText={touched.IdCardNo && errors.IdCardNo ? errors.IdCardNo : ''}
                               value={values.IdCardNo || ''}
                    onChange={(e) => {
                 const newValue = e.target.value;
                 
                 // Check if in edit mode and value has changed from initial
                 if (initialValue.IdCardNo && newValue !== initialValue.IdCardNo) {
                   // If there's an existing image, show confirmation dialog
                   if (senderImageFile || senderImagePreview) {
                     setPendingIdCardChanges(prev => ({ 
                       ...prev, 
                       sender: { newValue, field: 'IdCardNo' } 
                     }));
                     setShowIdCardChangeDialog(prev => ({ ...prev, sender: true }));
                     return; // Don't update the field yet
                   }
                 }
                 
                 // Update the field immediately if no image or not in edit mode
                 handleChange(e);
                 
                 // Clear the image and file input
                 setSenderImageFile(null);
                 setSenderImagePreview('');
                 const senderInput = document.getElementById('fileInputSender');
                 if (senderInput) {
                   senderInput.value = '';
                 }
               }}
                               disabled={!(values.idCardType && values.idCardType !== '' && values.idCardType !== '0')}
                               inputProps={{ maxLength: 30 }}
                             />
                           </Grid>
                         </Grid>
                       </Stack>
                     </Grid>
               
                     {/* Remarks Section - Middle Column */}
                     <Grid item md={4} xs={12}>
                       <Stack
                         direction="column"
                         justifyContent="center"
                         alignItems="center"
                         sx={{
                           height: '100%',
                           minHeight: { xs: 'auto', md: '250px' },
                           p: 2,
                         }}
                       >
                         <Typography
                           variant="subtitle2"
                           sx={{
                             fontWeight: 'bold',
                             textAlign: 'center',
                             color: 'text.secondary',
                             lineHeight: 1.4
                           }}
                         >
                            {sessionStorage.getItem('Origin') === 'SL' ? '' : <span style={{ color: 'red', display: 'block', marginBottom: 1 }}>Remarks</span>}
                           {sessionStorage.getItem('Origin') === 'UK' 
                             ? '“Dear Customer kindly upload the receiver document accordingly in the respective image upload option”'
                             : sessionStorage.getItem('Origin') === 'IN' ? '“Dear Customer kindly upload the Sender document accordingly in the respective image upload option”'
                            : ''}
                         </Typography>
                       </Stack>
                     </Grid>
               
                     {/* Receiver Section - Right Column */}
                     <Grid item md={4} xs={12}>
                       <Stack direction="column"  sx={{ height: '100%' }}>
                         {/* Receiver Image */}
                         <Stack
                           direction="row"
                           alignItems="center"
                           spacing={1}
                           border={1}
                           borderRadius={1}
                           borderColor="#e0e0e0"
                           p={1}
                           justifyContent="center"
                           sx={{
                             height: '100%',
                             bgcolor: 'background.paper',
                             minHeight: { xs: 'auto', md: '180px' }
                           }}
                         >
                           <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                             <Box sx={{ textAlign: 'center', width: '100%' }}>
                               <label htmlFor="fileInputReceiver">
                                 <img
                                   src={
                                     receiverImagePreview || imagepreview
                                     // (receiverImageFile === null ||
                                     //   receiverImageFile === '' ||
                                     //   !receiverImageFile
                                     //   ? imagepreview
                                     //   : NoimageFound)
                                   }
                                   alt="No Img"
                                   className={classes.chooseFileButton}
                                   style={{
                                     width: '100%',
                                     maxWidth: '250px',
                                     height: '150px',
                                     objectFit: 'contain',
                                   }}
                                    onError={(e) => {
                                     e.target.onerror = null; // Prevent infinite loop
                                     e.target.src = imagepreview;
                                     setReceivPreviewBtn(false)
                                   }}
                                 />
                                 <input
                                   className={classes.fileInput}
                                   id="fileInputReceiver"
                                   type="file"
                                   accept="image/jpeg"
                                   name="RecIDcardFile"
                                   onClick={(event)=>{
                                     if ((!values.RecIdCardNo || values.RecIdCardNo.trim() === '') || values.RecIdCardNo.trim() === '0') {
                                       openSnackBar('Please enter ID Card No before uploading image', 'error');
                                       event.preventDefault()
                                       event.stopPropagation();
                                       return;
                                     }
                                   }}
                                   onChange={(event) => {
                                     handleIdFileChange(event, 'receiver', values);
                                     handleChange(event);
                                   }}
                                   style={{ display: 'none' }}
                                  //  disabled={isDisabled}
                                 />
                               </label>
                               {((receiverImagePreview || receiverImageFile ) && (receivPreviewBtn)) && (
                                 <Button
                                   onClick={() => handleOpenDialogPreview('receiver')}
                                   variant="contained"
                                   color="primary"
                                   size="small"
                                   sx={{
                                     boxShadow: 1,
                                     mt: 1,
                                     width: '100%',
                                     maxWidth: '250px',
                                     mx: 'auto'
                                   }}
                                 >
                                   Preview
                                 </Button>
                               )}
                             </Box>
                           </Stack>
                         </Stack>
               
                         {/* Receiver ID Card Type and Number */}
                         <Grid container spacing={2} sx={{ mt: 0, p: 0 }}>
                           <Grid item xs={12} md={12}>
                             <FormControl fullWidth size="small">
                               <InputLabel>ID Card Type</InputLabel>
                               <Select
                                 value={values.RecidCardType || ''}
                                 name="RecidCardType"
                                 size="small"
                                 label="ID Card Type"
                                 onChange={(e) => {
                   const newValue = e.target.value;
                   
                   // Check if in edit mode and value has changed from initial
                   if ( initialValue.RecidCardType && newValue !== initialValue.RecidCardType) {
                     // If there's an existing image, show confirmation dialog
                     if (receiverImageFile || receiverImagePreview) {
                       setPendingIdCardChanges(prev => ({ 
                         ...prev, 
                         receiver: { newValue, field: 'RecidCardType', isTypeChange: true } 
                       }));
                       setShowIdCardChangeDialog(prev => ({ ...prev, receiver: true }));
                       return; // Don't update the field yet
                     }
                   }
                   
                   // Update the field immediately if no image or not in edit mode
                   setFieldValue('RecIdCardNo', '');
                   setReceiverImageFile(null);
                   setReceiverImagePreview('');
                   setFieldValue('RecidCardType', newValue || '');
                   const receiverInput = document.getElementById('fileInputReceiver');
                   if (receiverInput) {
                     receiverInput.value = '';
                   }
                 }}
                                 onBlur={handleBlur}
                                 error={touched.RecidCardType && !!errors.RecidCardType}
                                //  disabled={isDisabled}
                               >
                                 {idCardTypes.map((idCard) => (
                                   <MenuItem key={idCard.id} value={idCard.id}>
                                     {idCard.name}
                                   </MenuItem>
                                 ))}
                               </Select>
                             </FormControl>
                           </Grid>
               
                           <Grid item xs={12} md={12}>
                             <TextField
                               fullWidth
                               size="small"
                               label={
                                 <span>
                                   ID Card No
                                   {values.RecidCardType && values.RecidCardType !== '' && values.RecidCardType !== '0' ?
                                     <span style={{ color: 'red', marginLeft: '2px' }}>*</span> : null
                                   }
                                 </span>
                               }
                               type="text"
                               name="RecIdCardNo"
                               inputRef={el => { fieldRefs.current.RecIdCardNo = el; }}
                               onBlur={handleBlur}
                               error={touched.RecIdCardNo && !!errors.RecIdCardNo}
                               helperText={touched.RecIdCardNo && errors.RecIdCardNo ? errors.RecIdCardNo : ''}
                               value={values.RecIdCardNo || ''}
                    onChange={(e) => {
                 const newValue = e.target.value;
                 
                 // Check if in edit mode and value has changed from initial
                 if (initialValue.RecIdCardNo && newValue !== initialValue.RecIdCardNo) {
                   // If there's an existing image, show confirmation dialog
                   if (receiverImageFile || receiverImagePreview) {
                     setPendingIdCardChanges(prev => ({ 
                       ...prev, 
                       receiver: { newValue, field: 'RecIdCardNo' } 
                     }));
                     setShowIdCardChangeDialog(prev => ({ ...prev, receiver: true }));
                     return; // Don't update the field yet
                   }
                 }
                 
                 // Update the field immediately if no image or not in edit mode
                 handleChange(e);
                 
                 // Clear the image and file input
                 setReceiverImageFile(null);
                 setReceiverImagePreview('');
                 const receiverInput = document.getElementById('fileInputReceiver');
                 if (receiverInput) {
                   receiverInput.value = '';
                 }
               }}
                               disabled={!(values.RecidCardType && values.RecidCardType !== '' && values.RecidCardType !== '0')}
                               inputProps={{ maxLength: 30 }}
                             />
                           </Grid>
                   
                         </Grid>
                       </Stack>
                     </Grid>
                   </Grid>
                 </Grid>
               </Grid>
               {/* ID Card Change Confirmation Dialog for Sender */}
               <Dialog
                 open={showIdCardChangeDialog.sender}
                 onClose={() => setShowIdCardChangeDialog(prev => ({ ...prev, sender: false }))}
               >
                 <DialogTitle>
                   {pendingIdCardChanges.sender?.isTypeChange 
                     ? 'Confirm ID Card Type Change' 
                     : 'Confirm ID Card Number Change'}
                 </DialogTitle>
                 <DialogContent>
                   <DialogContentText>
                     {pendingIdCardChanges.sender?.isTypeChange 
                       ? 'If you change the ID card type, the existing ID card image and ID card number will be removed.'
                       : 'If you change the ID card number, the existing ID card image will be removed.'}
                     <br /><br />
                     Do you want to proceed? You will need to upload a new ID card image
                      {pendingIdCardChanges.sender?.isTypeChange ?' and ID card number.' : '.'}
                   </DialogContentText>
                 </DialogContent>
                 <DialogActions>
                   <Button 
                     onClick={() => {
                       // User clicked Cancel - revert to original value
                       if (pendingIdCardChanges.sender?.field === 'idCardType') {
                         setFieldValue('idCardType', initialValue.idCardType || '');
                       } else {
                         setFieldValue('IdCardNo', initialValue.IdCardNo || '');
                       }
                       setShowIdCardChangeDialog(prev => ({ ...prev, sender: false }));
                       setPendingIdCardChanges(prev => ({ ...prev, sender: null }));
                     }}
                     color="primary"
                   >
                     Cancel
                   </Button>
                   <Button 
                     onClick={() => {
                       // User clicked Confirm - proceed with change
                       if (pendingIdCardChanges.sender?.field === 'idCardType') {
                         setFieldValue('idCardType', pendingIdCardChanges.sender.newValue);
                         // Also clear ID card number when type changes
                         setFieldValue('IdCardNo', '');
                       } else {
                         setFieldValue('IdCardNo', pendingIdCardChanges.sender.newValue);
                       }
                       
                       // Clear the image and file input
                       setSenderImageFile(null);
                       setSenderImagePreview('');
                       const senderInput = document.getElementById('fileInputSender');
                       if (senderInput) {
                         senderInput.value = '';
                       }
                       
                       setShowIdCardChangeDialog(prev => ({ ...prev, sender: false }));
                       setPendingIdCardChanges(prev => ({ ...prev, sender: null }));
                     }}
                     color="error"
                     variant="contained"
                   >
                     Confirm & Remove Image
                   </Button>
                 </DialogActions>
               </Dialog>
               
               {/* ID Card Change Confirmation Dialog for Receiver */}
               <Dialog
                 open={showIdCardChangeDialog.receiver}
                 onClose={() => setShowIdCardChangeDialog(prev => ({ ...prev, receiver: false }))}
               >
                 <DialogTitle>
                   {pendingIdCardChanges.receiver?.isTypeChange 
                     ? 'Confirm ID Card Type Change' 
                     : 'Confirm ID Card Number Change'}
                 </DialogTitle>
                 <DialogContent>
                   <DialogContentText>
                     {pendingIdCardChanges.receiver?.isTypeChange 
                       ? 'If you change the ID card type, the existing ID card image and ID card number will be removed.'
                       : 'If you change the ID card number, the existing ID card image will be removed.'}
                     <br /><br />
                     Do you want to proceed? You will need to upload a new ID card image  
                     {pendingIdCardChanges.receiver?.isTypeChange ?' and ID card number.' : '.'}
                   </DialogContentText>
                 </DialogContent>
                 <DialogActions>
                   <Button 
                     onClick={() => {
                       // User clicked Cancel - revert to original value
                       if (pendingIdCardChanges.receiver?.field === 'RecidCardType') {
                         setFieldValue('RecidCardType', initialValue.RecidCardType || '');
                       } else {
                         setFieldValue('RecIdCardNo', initialValue.RecIdCardNo || '');
                       }
                       setShowIdCardChangeDialog(prev => ({ ...prev, receiver: false }));
                       setPendingIdCardChanges(prev => ({ ...prev, receiver: null }));
                     }}
                     color="primary"
                   >
                     Cancel 
                   </Button>
                   <Button 
                     onClick={() => {
                       // User clicked Confirm - proceed with change
                       if (pendingIdCardChanges.receiver?.field === 'RecidCardType') {
                         setFieldValue('RecidCardType', pendingIdCardChanges.receiver.newValue);
                         // Also clear ID card number when type changes
                         setFieldValue('RecIdCardNo', '');
                       } else {
                         setFieldValue('RecIdCardNo', pendingIdCardChanges.receiver.newValue);
                       }
                       
                       // Clear the image and file input
                       setReceiverImageFile(null);
                       setReceiverImagePreview('');
                       const receiverInput = document.getElementById('fileInputReceiver');
                       if (receiverInput) {
                         receiverInput.value = '';
                       }
                       
                       setShowIdCardChangeDialog(prev => ({ ...prev, receiver: false }));
                       setPendingIdCardChanges(prev => ({ ...prev, receiver: null }));
                     }}
                     color="error"
                     variant="contained"
                   >
                     Confirm & Remove Image
                   </Button>
                 </DialogActions>
               </Dialog>
                      <Grid item md={12} xs={12}>
                        <Divider sx={{ my: 2 }} variant="middle">
                          {/* <Chip label="Collection/Drop Details" size="small" color="success" variant="outlined" /> */}
                          <Chip label="Branch Details" size="small" color="success" variant="outlined" />
                        </Divider>
                      </Grid>
                      {/* <Grid item xs={6}>
                          <FormControl fullWidth size="small" required>
                            <InputLabel>Collection/Drop</InputLabel>
                            <Select
                              value={values.pickUpType || ''}
                              name="pickUpType"
                              size="small"
                              label="Collection/Drop"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={touched.pickUpType && !!errors.pickUpType}
                              required
                            >
                              {pickupTypes.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                            {touched.pickUpType && errors.pickUpType && (
                              <Typography
                                variant="caption"
                                color="error"
                                className="shake-helper-text"
                                margin="4px 0 0 14px"
                              >
                                {errors.pickUpType}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid> */}
                      <Grid item md={12} xs={12}>
                        <FormControl fullWidth size="small" required>
                          <InputLabel>Branch</InputLabel>
                          <Select
                            value={values.branch || ''}
                            name="branch"
                            inputRef={el => { fieldRefs.current.branch = el; }}
                            size="small"
                            label="Branch"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            required
                            error={touched.branch && !!errors.branch}
                          >
                            {branchList.length > 0 ? (
                              branchList.map((branch) => (
                                <MenuItem key={branch.BranchId} value={branch.BranchId}>
                                  {branch.BranchName}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>No branches available</MenuItem>
                            )}
                          </Select>
                          {touched.branch && errors.branch && (
                            <Typography
                              variant="caption"
                              color="error"
                              className="shake-helper-text"
                              margin="4px 0 0 14px"
                            >
                              {errors.branch}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Divider sx={{ my: 2 }} variant="middle">
                          {/* <Chip label="Collection/Drop Details" size="small" color="success" variant="outlined" /> */}
                          <Chip label="Box Details" size="small" color="info" variant="outlined" />
                        </Divider>
                      </Grid>
                       {boxDetails.length > 0 &&
                        boxDetails.map((box, index) => (
                          <Grid item md={12} xs={12} key={index}>
                            <Paper
                              elevation={2}
                              sx={{
                                p: 2,
                                mb: 1,
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'background.paper',
                                '&:hover': {
                                  boxShadow: 3,
                                },
                                transition: 'all 0.3s ease',
                              }}
                            >
                               <Typography variant="h6" align="left" color="#295F98"
                                      sx={{pb:1}}>
                                        Box {box.boxNo} - Details & Descriptions
                                      </Typography>
                            <Accordion
                              expanded={expanded[index] || false}
                              py={2}
                              sx={{
                                backgroundColor: 'inherit',
                                border: 0,
                                borderRadius: 2,
                                boxShadow: 1,
                                p: 0,
                                mt: 0.5,
                                mb: 1,
                                cursor: 'pointer',
                              }}
                              elevation={7}
                            >
                              <AccordionSummary
                                aria-controls={`panel${index}bh-content`}
                                id={`panel${index}bh-header`}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  toggleAccordion(index)
                                }}
                                sx={{
                                  '&.Mui-expanded': {
                                    backgroundColor: 'transparent',
                                  },
                                  '&:focus-within': {
                                    backgroundColor: 'transparent',
                                  },
                                  pb: 1,
                                }}
                              >
                                <Grid container spacing={2} alignItems="center" sx={{ width: '100%' }}>
                                
                                  {/* Row 2: No of Items, Load Button, Spacer, Controls */}
                                  <Grid item md={2} xs={12}>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      label="No of Items"
                                      type="number"
                                      value={box.noOfItems}
                                      onChange={(e) => {
                                        const updatedBoxes = [...boxDetails];
                                        const newNoOfItems = parseFloat(e.target.value) || '';
                                        if (newNoOfItems > 0 || newNoOfItems === '') {
                                          updatedBoxes[index].noOfItems = newNoOfItems;
                                          setBoxDetails(updatedBoxes);
                                        }
                                      }}
                                      name={`boxDetails[${index}].noOfItems`}
                                      onBlur={handleBlur}
                                      error={Boolean(
                                        errors[`boxDetails[${index}].noOfItems`] &&
                                        touched[`boxDetails[${index}].noOfItems`]
                                      )}
                                      helperText={
                                        touched[`boxDetails[${index}].noOfItems`] &&
                                        errors[`boxDetails[${index}].noOfItems`]
                                      }
                                      disabled={!boxLoadEnabled[index]}
                                      required
                                       onClick={(e) => {
                                          e.stopPropagation(); // This prevents the click from bubbling up to the accordion
                                        }}
                                        // Also add this to prevent focus from triggering accordion
                                        onFocus={(e) => {
                                          e.stopPropagation();
                                        }}
                                    />
                                  </Grid>

                                  {/* Load Button - Show only if goods not loaded */}
                                  {boxLoadEnabled[index] && (
                                    <Grid item md={1} xs={12}>
                                      <Button
                                        onClick={async () => {
                                          showLoading();
                                          const uom = uomList.find(i => i.DefaultUOM === 'Y') || 0;
                                          const updatedBoxes = [...boxDetails];
                                          updatedBoxes[index].goods = Array.from(
                                            { length: updatedBoxes[index].noOfItems || 1 },
                                            () => ({
                                              goodsName: '',
                                              uom: '',
                                              UOM_Id: uom.UOM_Id,
                                              UOM_Description: uom.UOM_Description,
                                              quantity: '',
                                              rate: '',
                                              value: '',
                                              newGoods: 'N',
                                              image: null,
                                              GoodsId: '0',
                                            })
                                          );
                                          setBoxDetails(updatedBoxes);
                                            setBoxLoadEnabled(prev => ({
                                                              ...prev,
                                                              [index]: false
                                                            }));
                                          hideLoading();
                                          toggleAccordion(index);
                                        }}
                                        variant="contained"
                                        color="warning"
                                        size="medium"
                                        fullWidth
                                      >
                                        Load
                                      </Button>
                                    </Grid>
                                  )}

                                  {/* Spacer */}
                                  <Grid item md={(box.goods && box.goods.length > 0) ? 7 : 8} xs={12}>
                                    <Box />
                                  </Grid>

                                  {/* Right-aligned Controls */}
                                  <Grid item md={1} xs={12}>
                                    <Stack 
                                      direction="row" 
                                      spacing={0.5}
                                      alignItems="center"
                                      justifyContent="flex-end">
                                      {boxDetails.length > 1 && (
                                        <IconButton
                                          aria-label="delete"
                                          color="error"
                                          size="small"
                                          onClick={() => {
                                            handleOpenConfirmDialog(index);
                                          }}
                                          // disabled={isDisabled}
                                          sx={{ p: 0.5 }}
                                        >
                                          <DeleteOutlineIcon />
                                        </IconButton>
                                      )}

                                      {boxDetails.length > 1 && <Divider orientation="vertical" flexItem sx={{ my: 0.5 }} />}

                                      <Button
                                        variant="text"
                                        color="secondary"
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          toggleAccordion(index)
                                        }}
                                        sx={{
                                          textTransform: 'none',
                                          minWidth: 'fit-content',
                                          px: 0.5,
                                          fontSize: '0.85rem',
                                          whiteSpace: 'nowrap', // Prevents text wrapping
                                          overflow: 'hidden', // Hides overflow if needed
                                          textOverflow: 'ellipsis',
                                        }}
                                      >
                                        {expanded[index] ? 'Hide Goods' : 'View Goods'}
                                      </Button>

                                      <IconButton
                                        aria-label="expand"
                                        color="secondary"
                                        size="small"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          toggleAccordion(index)
                                        }}
                                        sx={{
                                          p: 0.5,
                                          backgroundColor: expanded[index] ? 'action.hover' : 'transparent',
                                          borderRadius: '50%',
                                        }}
                                      >
                                        <ExpandMoreIcon
                                          sx={{
                                            transform: expanded[index] ? 'rotate(180deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.3s ease',
                                            fontSize: '1.2rem'
                                          }}
                                        />
                                      </IconButton>
                                    </Stack>
                                  </Grid>
                                </Grid>
                              </AccordionSummary>
                              <AccordionDetails>
                               {box.goods.length > 0 && (
                                  <>
                                    <Divider>
                                      <Chip
                                        label="Goods Description"
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                      />
                                    </Divider>
                                    <Stack justifyContent={'flex-end'} alignItems={'flex-end'} my={1}>
                                      <Button
                                        onClick={() => handleOpenDialog1()}
                                        variant="outlined"
                                        color="success"
                                        size="small"
                                      >
                                        Create New Item
                                      </Button>
                                    </Stack>
                                    <Grid container spacing={2} my={1}>
                                      {box.goods.map((goods, goodsIndex) => {
                                        const filteredGoodsList = goodsList.filter(
                                          (item) =>
                                            !box.goods.some(
                                              (otherGoods, otherIndex) =>
                                                otherIndex !== goodsIndex &&
                                                Number(otherGoods.GoodsId) === Number(item.GoodsId)
                                            )
                                        );
                                        return (
                                          <Grid item md={12} xs={12} key={`${index}-${goodsIndex}`}>
                                            <Paper
                                              elevation={2}
                                              sx={{
                                                p: 2,
                                                mb: 1,
                                                borderRadius: 2,
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                backgroundColor: 'background.paper',
                                                '&:hover': {
                                                  boxShadow: 3,
                                                },
                                                transition: 'all 0.3s ease',
                                              }}
                                            >
                                              <Grid container spacing={2}>
                                                <Grid item md={9} xs={12}>
                                                  <Stack
                                                    direction="row"
                                                    spacing={2}
                                                    sx={{
                                                      justifyContent: 'space-evenly',
                                                      alignItems: 'center',
                                                    }}
                                                  >
                                                    <Typography
                                                      variant="subtitle2"
                                                      align="center"
                                                      sx={{
                                                        bgcolor: goods.newGoods === 'Y' ? 'orange' : '#55679C',
                                                        borderRadius: '100%',
                                                        color: 'white',
                                                        width: '30px',
                                                        height: '30px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                      }}
                                                    >
                                                      {goodsIndex + 1}
                                                    </Typography>

                                                    <Autocomplete
                                                      fullWidth
                                                      size="small"
                                                      options={filteredGoodsList} // Array of goods options
                                                      filterOptions={startsWithFilter} // Custom filter
                                                      getOptionLabel={(option) => option.GoodsName || ''} // Customize display value
                                                      renderOption={(props, option) => (
                                                        <li {...props} key={option.GoodsId}>
                                                          {option.GoodsName}
                                                        </li>
                                                      )}
                                                      value={
                                                        goodsList.find(
                                                          (item) => Number(item.GoodsId) === Number(goods.GoodsId)
                                                        ) || null
                                                      }
                                                      onChange={(event, value) => {
                                                        if (value?.NotApplicable === 'Y') {
                                                          alert(
                                                            'This item is not applicable and cannot be selected.'
                                                          );
                                                          return;
                                                        }
                                                        handleGoodsChange(index, goodsIndex, 'goods', value || {});
                                                      }}
                                                      isOptionEqualToValue={(option, value) =>
                                                        option.GoodsId === value?.GoodsId
                                                      }
                                                      renderInput={(params) => (
                                                        <Tooltip
                                                          title={params.inputProps.value || ''}
                                                          placement="top"
                                                          arrow
                                                          disableHoverListener={!params.inputProps.value} // Only show if there's a value
                                                        >
                                                          <TextField
                                                            required
                                                            {...params}
                                                            label='Goods'
                                                            name={`boxDetails[${index}].goods[${goodsIndex}].goodsName`}
                                                            error={Boolean(
                                                              errors[
                                                              `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                              ] &&
                                                              touched[
                                                              `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                              ]
                                                            )}
                                                            helperText={
                                                              touched[
                                                              `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                              ] &&
                                                              errors[
                                                              `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                              ]
                                                            }
                                                            onBlur={handleBlur}
                                                          />
                                                        </Tooltip>
                                                      )}
                                                    />
                                                  </Stack>
                                                </Grid>
                                               {hideUom &&  <Grid item md={3} xs={12}>
                                                  <Autocomplete
                                                    fullWidth
                                                    size="small"
                                                    options={uomList} // Array of goods options
                                                    getOptionLabel={(option) => option.UOM_Description || ''} // Customize display value
                                                    renderOption={(props, option) => (
                                                      <li {...props} key={option.UOM_Id}>
                                                        {option.UOM_Description}
                                                      </li>
                                                    )}
                                                    value={uomList.find((item) => Number(item.UOM_Id) === Number(goods.UOM_Id)) || null}
                                                    // value={
                                                    //   uomList.find((item) => item.UOM_Id === goods.UOM_Id) || 
                                                    //   uomList.find((item) => item.DefaultUOM === 'Y') || 
                                                    //   null
                                                    // }
                                                    onChange={(event, value) => {
                                                      handleGoodsChange(index, goodsIndex, 'uom', value || {}); // Update value
                                                    }}
                                                    isOptionEqualToValue={(option, value) =>
                                                      option.UOM_Id === value?.UOM_Id
                                                    }
                                                    renderInput={(params) => (
                                                      <TextField
                                                        {...params}
                                                        label="UOM"
                                                        name={`boxDetails[${index}].goods[${goodsIndex}].uom`}
                                                        error={Boolean(
                                                          errors[`boxDetails[${index}].goods[${goodsIndex}].uom`] &&
                                                          touched[`boxDetails[${index}].goods[${goodsIndex}].uom`]
                                                        )}
                                                        helperText={
                                                          touched[`boxDetails[${index}].goods[${goodsIndex}].uom`] &&
                                                          errors[`boxDetails[${index}].goods[${goodsIndex}].uom`]
                                                        }
                                                        onBlur={handleBlur}
                                                      />
                                                    )}
                                                  />
                                                </Grid>}
                                                <Grid item md={4} xs={12}>
                                                  <TextField
                                                    required
                                                    fullWidth
                                                    size="small"
                                                    label="Quantity"
                                                    type="number"
                                                    value={goods.quantity}
                                                    onChange={(e) => {
                                                      const newQty = parseFloat(e.target.value) || '';
                                                      if (newQty > 0 || newQty === '') {
                                                        handleGoodsChange(index, goodsIndex, 'quantity', newQty);
                                                      }
                                                    }}
                                                    name={`boxDetails[${index}].goods[${goodsIndex}].quantity`}
                                                    onBlur={handleBlur}
                                                    error={Boolean(
                                                      errors[`boxDetails[${index}].goods[${goodsIndex}].quantity`] &&
                                                      touched[`boxDetails[${index}].goods[${goodsIndex}].quantity`]
                                                    )}
                                                    helperText={
                                                      touched[`boxDetails[${index}].goods[${goodsIndex}].quantity`] &&
                                                      errors[`boxDetails[${index}].goods[${goodsIndex}].quantity`]
                                                    }
                                                  />
                                                </Grid>
                                                <Grid item md={4} xs={12}>
                                                  <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Rate"
                                                    type="number"
                                                    value={goods.rate}
                                                    onChange={(e) => {
                                                      const newRate = parseFloat(e.target.value) || '';
                                                      if (newRate > 0 || newRate === '') {
                                                        handleGoodsChange(index, goodsIndex, 'rate', newRate);
                                                      }
                                                    }}
                                                    onBlur={handleBlur}
                                                    name={`boxDetails[${index}].goods[${goodsIndex}].rate`}
                                                    error={Boolean(
                                                      errors[`boxDetails[${index}].goods[${goodsIndex}].rate`] &&
                                                      touched[`boxDetails[${index}].goods[${goodsIndex}].rate`]
                                                    )}
                                                    helperText={
                                                      touched[`boxDetails[${index}].goods[${goodsIndex}].rate`] &&
                                                      errors[`boxDetails[${index}].goods[${goodsIndex}].rate`]
                                                    }
                                                  />
                                                </Grid>
                                                <Grid item md={4} xs={12}>
                                                  <Stack
                                                    direction="row"
                                                    spacing={1}
                                                    sx={{
                                                      justifyContent: 'space-evenly',
                                                      alignItems: 'center',
                                                    }}
                                                  >
                                                    <TextField
                                                      fullWidth
                                                      size="small"
                                                      label="Value"
                                                      type="number"
                                                      value={goods.value}
                                                      name={`boxDetails[${index}].goods[${goodsIndex}].value`}
                                                      onBlur={handleBlur}
                                                      error={Boolean(
                                                        errors[`boxDetails[${index}].goods[${goodsIndex}].value`] &&
                                                        touched[`boxDetails[${index}].goods[${goodsIndex}].value`]
                                                      )}
                                                      helperText={
                                                        touched[`boxDetails[${index}].goods[${goodsIndex}].value`] &&
                                                        errors[`boxDetails[${index}].goods[${goodsIndex}].value`]
                                                      }
                                                      disabled
                                                    />
                                                    {box.goods.length > 1 && (
                                                      <IconButton
                                                        aria-label="delete"
                                                        onClick={() => handleDeleteGoods(index, goodsIndex)}
                                                        color="error"
                                                      >
                                                        <HighlightOffIcon />
                                                      </IconButton>
                                                    )}
                                                  </Stack>
                                                </Grid>
                                              </Grid>
                                            </Paper>
                                          </Grid>
                                        );
                                      })}
                                    </Grid>
                                    <Stack justifyContent={'center'} alignItems={'center'} mt={2}>
                                      <Button
                                        onClick={() => {
                                          handleAddGoods(index, 'N');
                                        }}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        startIcon={<AddIcon />}
                                      >
                                        Add More Item
                                      </Button>
                                    </Stack>
                                    <Typography variant="h6" align="right" color="#347928" mt={2} mx={2}>
                                      Total: {getTotalValue(index)}
                                    </Typography>
                                  </>
                                )}
                              </AccordionDetails>
                            </Accordion>
                         <Grid item md={12} xs={12}>
                                    <Typography variant="h6" align="left" color="#295F98">
                                       Dimensions & Weights
                                    </Typography>
                                  </Grid>
                            
                              <Grid container spacing={2}>
                                {values.shipMentType !== 'SCSL' ? (
                                    <>
                                      <Grid item md={2} xs={12}>
                                        <TextField
                                          required
                                          size="small"
                                          fullWidth
                                          label="Length"
                                          type="number"
                                          value={box.length}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newLength = parseFloat(e.target.value) || '';
                                            if (newLength > 0 || newLength === '') {
                                              updatedBoxes[index].length = newLength;
                                              const rawCubicWeight =
                                                values.dimensionType === 'CM'
                                                  ? (box.height * box.width * newLength) / 5000
                                                  : (box.height * box.width * newLength) / 1925;
                                              updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                              setBoxDetails(updatedBoxes);
                                              GetCourierShipperPrice(updatedBoxes);
                                              
                                              // Check for oversize condition on current box only (when NOT SCSL)
                                              if (values.shipMentType !== 'SCSL' && newLength >= 100) {
                                                showOversizeWarning();
                                              }
                                            }
                                          }}
                                          name={`boxDetails[${index}].length`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].length`] &&
                                            touched[`boxDetails[${index}].length`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].length`] &&
                                            errors[`boxDetails[${index}].length`]
                                          }
                                        />
                                      </Grid>
                                      <Grid item md={2} xs={12}>
                                        <TextField
                                          required
                                          fullWidth
                                          size="small"
                                          label="Width"
                                          type="number"
                                          value={box.width}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newWidth = parseFloat(e.target.value) || '';
                                            if (newWidth > 0 || newWidth === '') {
                                              updatedBoxes[index].width = newWidth;
                                              const rawCubicWeight =
                                                values.dimensionType === 'CM'
                                                  ? (box.height * box.length * newWidth) / 5000
                                                  : (box.height * box.length * newWidth) / 1925;
                                              updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                              setBoxDetails(updatedBoxes);
                                              GetCourierShipperPrice(updatedBoxes);
                                              
                                              // Check for oversize condition on current box only (when NOT SCSL)
                                              if (values.shipMentType !== 'SCSL' && newWidth >= 100) {
                                                showOversizeWarning();
                                              }
                                            }
                                          }}
                                          name={`boxDetails[${index}].width`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].width`] &&
                                            touched[`boxDetails[${index}].width`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].width`] &&
                                            errors[`boxDetails[${index}].width`]
                                          }
                                        />
                                      </Grid>
                                      <Grid item md={2} xs={12}>
                                        <TextField
                                          required
                                          fullWidth
                                          size="small"
                                          label="Height"
                                          type="number"
                                          value={box.height}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newHeight = parseFloat(e.target.value) || '';
                                            if (newHeight > 0 || newHeight === '') {
                                              updatedBoxes[index].height = newHeight;
                                              const rawCubicWeight =
                                                values.dimensionType === 'CM'
                                                  ? (newHeight * box.length * box.width) / 5000
                                                  : (newHeight * box.length * box.width) / 1925;
                                              updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                              setBoxDetails(updatedBoxes);
                                              GetCourierShipperPrice(updatedBoxes);
                                              
                                              // Check for oversize condition on current box only (when NOT SCSL)
                                              if (values.shipMentType !== 'SCSL' && newHeight >= 100) {
                                                showOversizeWarning();
                                              }
                                            }
                                          }}
                                          name={`boxDetails[${index}].height`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].height`] &&
                                            touched[`boxDetails[${index}].height`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].height`] &&
                                            errors[`boxDetails[${index}].height`]
                                          }
                                        />
                                      </Grid>
                                      <Grid item md={2} xs={12}>
                                        <TextField
                                          required
                                          fullWidth
                                          size="small"
                                          label="Cubic Weight"
                                          type="number"
                                          value={box.cubicWeight}
                                          disabled
                                          name={`boxDetails[${index}].cubicWeight`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].cubicWeight`] &&
                                            touched[`boxDetails[${index}].cubicWeight`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].cubicWeight`] &&
                                            errors[`boxDetails[${index}].cubicWeight`]
                                          }
                                        />
                                      </Grid>
                                      <Grid item md={2} xs={12}>
                                        <TextField
                                          required
                                          fullWidth
                                          size="small"
                                          label="Gross Weight"
                                          type="number"
                                          value={box.grossWeight}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newGrossWeight = parseFloat(e.target.value) || '';
                                            if (newGrossWeight > 0 || newGrossWeight === '') {
                                              updatedBoxes[index].grossWeight = newGrossWeight;
                                              setBoxDetails(updatedBoxes);
                                              GetCourierShipperPrice(updatedBoxes);
                                              
                                              // Check for overweight condition on current box only (when NOT SCSL)
                                              if (values.shipMentType !== 'SCSL' && newGrossWeight >= 31) {
                                                showOverweightWarning();
                                              }
                                            }
                                          }}
                                          name={`boxDetails[${index}].grossWeight`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].grossWeight`] &&
                                            touched[`boxDetails[${index}].grossWeight`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].grossWeight`] &&
                                            errors[`boxDetails[${index}].grossWeight`]
                                          }
                                        />
                                      </Grid>
                                    </>
                                  ) : (
                                    <>
                                      <Grid item md={3} xs={12}>
                                        <Autocomplete
                                          fullWidth
                                          size="small"
                                          options={BoxType}
                                          getOptionLabel={(option) => option.label || ''}
                                          renderOption={(props, option) => (
                                            <li {...props} key={option.value}>
                                              {option.label}
                                            </li>
                                          )}
                                          value={BoxType.find((item) => item.value === box.BoxType) || null}
                                          onChange={(event, value) => {
                                            const updatedBoxes = [...boxDetails];
                                            updatedBoxes[index] = {
                                              ...updatedBoxes[index],
                                              BoxType: value ? value.value : null,
                                              length: '',
                                              width: '',
                                              height: '',
                                              dimensionType: 'CM',
                                              BOXTYPEID: null,
                                              BoxSize: '',
                                              grossWeight: '',
                                              cubicWeight: '',
                                            };
                                            setBoxDetails(updatedBoxes);
                                            setInitialValue(values);
                                          }}
                                          isOptionEqualToValue={(option, value) => option.value === value?.value}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              required
                                              label="Select Box"
                                              name={`boxDetails[${index}].BoxType`}
                                              onBlur={handleBlur}
                                              error={Boolean(
                                                errors[`boxDetails[${index}].BoxType`] &&
                                                touched[`boxDetails[${index}].BoxType`]
                                              )}
                                              helperText={
                                                touched[`boxDetails[${index}].BoxType`] &&
                                                errors[`boxDetails[${index}].BoxType`]
                                              }
                                            />
                                          )}
                                        />
                                      </Grid>
                                      <Grid item md={3} xs={12}>
                                        {box.BoxType === 'Custom' ? (
                                          <TextField
                                            required
                                            fullWidth
                                            size="small"
                                            label="Box Type"
                                            type="text"
                                            value={box.BoxSize}
                                            onChange={(e) => {
                                              const updatedBoxes = [...boxDetails];
                                              updatedBoxes[index].BoxSize = e.target.value;
                                              setBoxDetails(updatedBoxes);
                                            }}
                                            name={`boxDetails[${index}].BoxSize`}
                                            onBlur={handleBlur}
                                            error={Boolean(
                                              errors[`boxDetails[${index}].BoxSize`] &&
                                              touched[`boxDetails[${index}].BoxSize`]
                                            )}
                                            helperText={
                                              touched[`boxDetails[${index}].BoxSize`] &&
                                              errors[`boxDetails[${index}].BoxSize`]
                                            }
                                          />
                                        ) : (
                                          <Autocomplete
                                            fullWidth
                                            size="small"
                                            options={boxSizeList}
                                            getOptionLabel={(option) => `${option.BOXTYPE} (${option.BOXSIZE})` || ''}
                                            renderOption={(props, option) => (
                                              <li {...props} key={option.BOXTYPEID}>
                                                {`${option.BOXTYPE} (${option.BOXSIZE})`}
                                              </li>
                                            )}
                                            value={
                                              boxSizeList.find((item) => item.BOXTYPEID === box.BOXTYPEID) || null
                                            }
                                            onChange={(event, value) => {
                                              handleBoxSizeChange(index, 'BoxSize', value || {}, values);
                                            }}
                                            isOptionEqualToValue={(option, value) =>
                                              option.BOXTYPEID === value?.BOXTYPEID
                                            }
                                            renderInput={(params) => (
                                              <TextField
                                                required
                                                {...params}
                                                label="Box Size"
                                                name={`boxDetails[${index}].BoxSize`}
                                                error={Boolean(
                                                  errors[`boxDetails[${index}].BoxSize`] &&
                                                  touched[`boxDetails[${index}].BoxSize`]
                                                )}
                                                helperText={
                                                  touched[`boxDetails[${index}].BoxSize`] &&
                                                  errors[`boxDetails[${index}].BoxSize`]
                                                }
                                                onBlur={handleBlur}
                                              />
                                            )}
                                          />
                                        )}
                                      </Grid>
                                      <Grid item md={2} xs={12}>
                                        <TextField
                                          required
                                          size="small"
                                          fullWidth
                                          label="Length"
                                          type="number"
                                          value={box.length}
                                          disabled={box.BoxType !== 'Custom'}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newLength = parseFloat(e.target.value) || '';
                                            if (newLength > 0 || newLength === '') {
                                              updatedBoxes[index].length = newLength;
                                              const rawCubicWeight =
                                                box.dimensionType === 'CM'
                                                  ? (Number(box.height) / 100) *
                                                  (Number(newLength) / 100) *
                                                  (Number(box.width) / 100)
                                                  : Number(box.height) *
                                                  0.0254 *
                                                  (Number(newLength) * 0.0254) *
                                                  (Number(box.width) * 0.0254);
                                              updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                              setBoxDetails(updatedBoxes);
                                              GetCargoNewShipperPrice(values.receiverCountry, updatedBoxes);
                                            }
                                          }}
                                          name={`boxDetails[${index}].length`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].length`] &&
                                            touched[`boxDetails[${index}].length`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].length`] &&
                                            errors[`boxDetails[${index}].length`]
                                          }
                                        />
                                      </Grid>
                                      <Grid item md={2} xs={12}>
                                        <TextField
                                          required
                                          fullWidth
                                          size="small"
                                          label="Width"
                                          type="number"
                                          value={box.width}
                                          disabled={box.BoxType !== 'Custom'}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newWidth = parseFloat(e.target.value) || '';
                                            if (newWidth > 0 || newWidth === '') {
                                              updatedBoxes[index].width = newWidth;
                                              const rawCubicWeight =
                                                box.dimensionType === 'CM'
                                                  ? (Number(box.height) / 100) *
                                                  (Number(box.length) / 100) *
                                                  (Number(newWidth) / 100)
                                                  : Number(box.height) *
                                                  0.0254 *
                                                  (Number(box.length) * 0.0254) *
                                                  (Number(newWidth) * 0.0254);
                                              updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                              setBoxDetails(updatedBoxes);
                                              GetCargoNewShipperPrice(values.receiverCountry, updatedBoxes);
                                            }
                                          }}
                                          name={`boxDetails[${index}].width`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].width`] &&
                                            touched[`boxDetails[${index}].width`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].width`] &&
                                            errors[`boxDetails[${index}].width`]
                                          }
                                        />
                                      </Grid>
                                      <Grid item md={2} xs={12}>
                                        <TextField
                                          required
                                          fullWidth
                                          size="small"
                                          label="Height"
                                          type="number"
                                          value={box.height}
                                          disabled={box.BoxType !== 'Custom'}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newHeight = parseFloat(e.target.value) || '';
                                            if (newHeight > 0 || newHeight === '') {
                                              updatedBoxes[index].height = newHeight;
                                              const rawCubicWeight =
                                                box.dimensionType === 'CM'
                                                  ? (Number(newHeight) / 100) *
                                                  (Number(box.length) / 100) *
                                                  (Number(box.width) / 100)
                                                  : Number(newHeight) *
                                                  0.0254 *
                                                  (Number(box.length) * 0.0254) *
                                                  (Number(box.width) * 0.0254);
                                              updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                              setBoxDetails(updatedBoxes);
                                              GetCargoNewShipperPrice(values.receiverCountry, updatedBoxes);
                                            }
                                          }}
                                          name={`boxDetails[${index}].height`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].height`] &&
                                            touched[`boxDetails[${index}].height`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].height`] &&
                                            errors[`boxDetails[${index}].height`]
                                          }
                                        />
                                      </Grid>
                                      <Grid item md={3} xs={12}>
                                        <Autocomplete
                                          fullWidth
                                          size="small"
                                          clearIcon={false}
                                          options={DimensionType}
                                          disabled={box.BoxType !== 'Custom'}
                                          getOptionLabel={(option) => option.label || ''}
                                          renderOption={(props, option) => (
                                            <li {...props} key={option.value}>
                                              {option.label}
                                            </li>
                                          )}
                                          value={
                                            DimensionType.find((item) => item.value === box.dimensionType) || null
                                          }
                                          onChange={(event, value) => {
                                            const updatedBoxes = [...boxDetails];
                                            updatedBoxes[index] = {
                                              ...updatedBoxes[index],
                                              dimensionType: value ? value.value : null,
                                            };
                                            const rawCubicWeight =
                                              value.value === 'CM'
                                                ? (Number(box.height) / 100) *
                                                (Number(box.length) / 100) *
                                                (Number(box.width) / 100)
                                                : Number(box.height) *
                                                0.0254 *
                                                (Number(box.length) * 0.0254) *
                                                (Number(box.width) * 0.0254);
                                            updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                            setBoxDetails(updatedBoxes);
                                            GetCargoNewShipperPrice(values.receiverCountry, updatedBoxes);
                                          }}
                                          isOptionEqualToValue={(option, value) => option.value === value?.value}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              required
                                              label="Dimension"
                                              name={`boxDetails[${index}].dimensionType`}
                                              onBlur={handleBlur}
                                              error={Boolean(
                                                errors[`boxDetails[${index}].dimensionType`] &&
                                                touched[`boxDetails[${index}].dimensionType`]
                                              )}
                                              helperText={
                                                touched[`boxDetails[${index}].dimensionType`] &&
                                                errors[`boxDetails[${index}].dimensionType`]
                                              }
                                            />
                                          )}
                                        />
                                      </Grid>
                                      <Grid item md={3} xs={12}>
                                        <TextField
                                          required
                                          fullWidth
                                          size="small"
                                          label="CBM"
                                          type="number"
                                          value={box.cubicWeight === 0 ? '' : box.cubicWeight}
                                          disabled
                                          name={`boxDetails[${index}].cubicWeight`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].cubicWeight`] &&
                                            touched[`boxDetails[${index}].cubicWeight`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].cubicWeight`] &&
                                            errors[`boxDetails[${index}].cubicWeight`]
                                          }
                                        />
                                      </Grid>
                                      <Grid item md={3} xs={12}>
                                        <TextField
                                          required
                                          fullWidth
                                          size="small"
                                          label="Gross Weight (kg)"
                                          type="number"
                                          value={box.grossWeight}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newGrossWeight = parseFloat(e.target.value) || '';
                                            if (newGrossWeight > 0 || newGrossWeight === '') {
                                              updatedBoxes[index].grossWeight = newGrossWeight;
                                              setBoxDetails(updatedBoxes);
                                            }
                                          }}
                                          name={`boxDetails[${index}].grossWeight`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].grossWeight`] &&
                                            touched[`boxDetails[${index}].grossWeight`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].grossWeight`] &&
                                            errors[`boxDetails[${index}].grossWeight`]
                                          }
                                        />
                                      </Grid>
                                    </>
                                  )}
                                </Grid>
                              
                            </Paper>
                          </Grid>
                        ))}
                      {/* {Origin === 'IN' && ( */}
                      <Grid item md={12} xs={12}>
                        <Stack direction="row" justifyContent="center" sx={{ width: '100%' }} p={0} m={0}>
                          <Button
                            variant="contained"
                            color={'info'}
                            size="small"
                            sx={{ boxShadow: 1 }}
                            onClick={() => {
                              handleAddBox(setFieldValue, values);
                              // setFieldValue('NofoBoxes', boxDetails.length + 1);
                            }}
                            fullWidth
                          >
                            Add Another Box
                          </Button>
                        </Stack>
                      </Grid>
                    </>
                  )}
                </Grid>

                <div style={{ position: 'sticky', bottom: 0 }}>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    gap={2}
                    sx={{
                      textAlign: 'center',
                      mt: 3,
                    }}
                  >
                    <Stack
                      direction="row"
                      justifyContent="center"
                      gap={2}
                      sx={{
                        backgroundColor: '#7ca3e94f',
                        padding: '10px',
                        borderRadius: '10px',
                        backdropFilter: 'blur(4px)',
                      }}
                    >
                      <Button
                        onClick={() => {
                          setOpen(!open);
                          setEditID('');
                          setInitialValue({ ...resetStates });
                          setAddDialogOpenState(false);
                          getAllData();
                        }}
                        variant="contained"
                        color={'warning'}
                        size="small"
                        sx={{ boxShadow: 1 }}
                      >
                        Close
                      </Button>
                      {bookingStarted &&
                        <Button
                          onClick={() => handleValidationFlow(values, validateForm)}
                          // onClick={() => {
                          //   if (!validateBoxGoodsDetails(boxDetails)) {
                          //     return; // Stop further processing if validation fails
                          //   }

                          //   if (Number(values.senderCountry) !== Number(senderSecondaryCountryId) && sameAsSender === true) {
                          //     setOpenConfirmDialog1(true);
                          //     const selectedCountry = countryList.find((d) => Number(d.CountryId) === Number(values.senderCountry));
                          //     const customerCountry = countryList.find((d) => Number(d.CountryId) === Number(senderSecondaryCountryId));
                          //     setChangeContent(`There is a mismatch between the sender's country as selected (${selectedCountry.CountryName}) 
                          //           and the one recorded in the customer record (${customerCountry.CountryName}). Please review and update the country as necessary.`);
                          //     return;
                          //   }

                          //   setSubmitConfirmation(true);
                          // }}
                          disabled={isSubmitting}
                          variant="contained"
                          color="primary"
                          size="success"
                          sx={{ boxShadow: 1 }}
                        >
                          {'Complete Order'}
                        </Button>
                      }
                      {bookingStarted &&
                        <Button
                          onClick={() => {
                            if(values.shipMentType !== 'SCSL')
                            {
                            submitCourierOrder({ ...initialValue, ...values }, 'Y');
                            }
                            else {
                              submitCargoOrder({ ...initialValue, ...values }, 'Y')
                            }
                          }}
                          variant="contained"
                          color="inherit"
                          size="small"
                          sx={{ boxShadow: 1 }}
                        >
                          Save As Draft
                        </Button>
                      }
                      {!bookingStarted &&
                        <Button
                          variant={'contained'}
                          color={'primary'}
                          size={'small'}
                          sx={{ boxShadow: 1 }}
                          type={'submit'}
                          onClick={async () => {
                            if (bookingStarted) {
                              setResetOpenDialog(true);
                            } else {
                              const formErrors = await validateForm();
                              if (Object.keys(formErrors).length === 0) {
                                handleBoxCountChange(values.NofoBoxes, values.shipMentType);
                                setBookingStarted(true);
                              }
                            }
                          }}
                          fullWidth={bookingStarted}
                        >
                          {'Start Booking'}
                        </Button>
                      }
                    </Stack>
                  </Stack>
                </div>

                {/* Confirmation Dialog */}
                <Dialog open={submitConfirmation} onClose={() => setSubmitConfirmation(false)}>
                  <DialogTitle>Confirm Submission</DialogTitle>
                  <DialogContent>
                    <p>Are you sure you want to submit?</p>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setSubmitConfirmation(false)} color="warning" variant="contained">
                      Cancel
                    </Button>
                    <Button
                      onClick={() => {
                        if (values.receiverCountry.length === 0) {
                          setreceiverCountryErr(true);
                        } else {
                          setreceiverCountryErr(false);
                        }
                        if (values.senderCountry.length === 0) {
                          setsenderCountryErr(true);
                        } else {
                          setsenderCountryErr(false);
                        }
                        submitForm();
                        setSubmitConfirmation(false);
                      }}
                      disabled={isSubmitting}
                      variant="contained"
                      color="primary"
                      size="success"
                      sx={{ boxShadow: 1 }}
                    >
                      Confirm
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* Confirmation Dialog for Deletion */}
                <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
                  <DialogTitle>Confirm Deletion</DialogTitle>
                  <DialogContent>
                    <Typography>Are you sure you want to delete this box?</Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseConfirmDialog} color="primary">
                      Cancel
                    </Button>
                    <Button
                      onClick={async () => {
                        showLoading();
                        setInitialValue(values);
                        const updatedBoxDetails = [...boxDetails];
                        updatedBoxDetails.splice(boxToDelete, 1);
                        const reIndexedBoxDetails = updatedBoxDetails.map((box, index) => ({
                          ...box,
                          boxNo: index + 1,
                        }));

                        setBoxDetails(reIndexedBoxDetails);
                        if (values.shipMentType !== 'SCSL') {
                          GetCourierShipperPrice(reIndexedBoxDetails);
                        } else {
                          // GetCargoShipperPrice1(null, null, null, reIndexedBoxDetails);
                          GetCargoNewShipperPrice(values.receiverCountry, reIndexedBoxDetails);
                        }
                        setTimeout(async () => {
                          await new Promise((resolve) => {
                            setFieldValue('NofoBoxes', reIndexedBoxDetails.length, () => resolve());
                          });
                        }, 1000);
                        hideLoading();
                        handleCloseConfirmDialog();
                      }}
                      color="error"
                    >
                      Delete
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* Confirmation reset Dialog */}
                <Dialog
                  open={resetOpenDialog}
                  onClose={() => setResetOpenDialog(false)}
                  aria-labelledby="confirm-dialog-title"
                  aria-describedby="confirm-dialog-description"
                >
                  <DialogTitle id="confirm-dialog-title">Confirm Reset</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="confirm-dialog-description">
                      Are you sure you want to reset the form? This action cannot be undone.
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setResetOpenDialog(false)} color="primary">
                      Cancel
                    </Button>
                    <Button
                      onClick={() => {
                        resetForm();
                        resetBooking();
                        setErrors({});
                        setTouched({});
                        setSenderImageFile(null);
                        setSenderImagePreview('');
                        setReceiverImageFile(null);
                        setReceiverImagePreview('');
                        setsameAsSender(false);
                        setResetOpenDialog(false);
                      }}
                      color="error"
                      autoFocus
                    >
                      Confirm
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* Add New Item */}
                <Dialog open={dialogOpen1} fullWidth maxWidth="sm">
                  <DialogTitle>Create New Item</DialogTitle>
                  <DialogContent>
                    <Grid container spacing={1} p={1}>
                      <Grid item md={12} xs={12}>
                        <Typography variant="subtitle2" color="GrayText" pr={1}>
                          {/* Goods Description{' '} */}

                          <TextField
                            fullWidth
                            size="small"
                            label={
                              <>
                                Goods Description <span style={{ color: 'red' }}>*</span>
                              </>
                            }
                            type="text"
                            name="GoodsName"
                            value={goodsdescription}
                            onChange={(e) => {
                              setgoodsdescription(e.target.value);
                            }}
                            required
                          />
                          {goodsdescriptionErr && (
                            <span style={{ color: 'red' }}>Please enter the goods description</span>
                          )}
                        </Typography>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Typography variant="subtitle2" color="GrayText" pr={1}>
                          {/* Rate{' '} */}
                          <TextField
                            fullWidth
                            size="small"
                            label="Rate"
                            type="number"
                            name="Rate"
                            value={rate}
                            onChange={(e) => {
                              const newRate = parseFloat(e.target.value) || '';
                              if (newRate > 0 || newRate === '') {
                                setrate(e.target.value);
                              }
                            }}
                          />
                        </Typography>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Typography variant="subtitle2" color="GrayText" pr={1}>
                          {/* HSN Code{' '} */}
                          <TextField
                            fullWidth
                            size="small"
                            label="HSN Code"
                            type="text"
                            name="HSN"
                            value={hsnCodes}
                            onChange={(e) => {
                              sethsnCodes(e.target.value);
                            }}
                          />
                        </Typography>
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={active}
                              onChange={(e) => {
                                setactive(e.target.checked);
                              }}
                              name="activeCheckbox"
                              color="primary"
                            />
                          }
                          label="Active"
                        />
                      </Grid>
                    </Grid>

                    <Stack justifyContent={'center'} direction={'row'} spacing={2} alignItems={'center'}>
                      {' '}
                      <Button onClick={handleCloseDialog1} color="warning" variant="contained" size="small">
                        Close
                      </Button>
                      <Button
                        onClick={() => {
                          InsertGoodsMst();
                        }}
                        color="success"
                        variant="contained"
                        size="small"
                      >
                        {'Add'}
                      </Button>
                    </Stack>
                  </DialogContent>
                </Dialog>

                {/* Dialog for Image Preview */}
                <Dialog open={openDialogPreview} onClose={handleCloseDialogPreview} maxWidth="md">
                  <DialogTitle>Image Preview</DialogTitle>
                  <DialogContent>
                    <img
                      src={
                        previewTarget === 'sender'
                          ? (senderImagePreview || imagepreview)
                          : previewTarget === 'receiver'
                          ? (receiverImagePreview || imagepreview)
                          : (imagePreview || imagepreview)
                      }
                      alt="Preview"
                      style={{
                        maxWidth: '100%',
                        maxHeight: '400px',
                        objectFit: 'contain',
                      }}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
                      <Stack direction="row" spacing={1}>
                        <Button
                          onClick={handleOpenConfirmDialogDelete}
                          color="error"
                          variant="outlined"
                          size="small"
                          startIcon={<DeleteOutlineIcon />}
                        >
                          Delete
                        </Button>
                        
                        {/* Download Button */}
                        <Button
                          onClick={() => {
                            // Determine which image to download
                            let imageUrl = '';
                            let fileName = '';
                            
                            if (previewTarget === 'sender') {
                              imageUrl = senderImagePreview;
                              fileName = `ID_card_${values.IdCardNo || 'unknown'}.jpg`;
                            } else if (previewTarget === 'receiver') {
                              imageUrl = receiverImagePreview;
                              fileName = `ID_card_${values.RecIdCardNo || 'unknown'}.jpg`;
                            }
                            
                            // Download the image
                            if (imageUrl && imageUrl !== imagepreview) {
                              const link = document.createElement('a');
                              link.href = imageUrl;
                              link.download = fileName;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            } else {
                              openSnackBar('No image available to download', 'warning');
                            }
                          }}
                          color="primary"
                          variant="contained"
                          size="small"
                          startIcon={<FileDownloadIcon />}
                        >
                          Download
                        </Button>
                      </Stack>
                      
                      <Button
                        onClick={handleCloseDialogPreview}
                        color="primary"
                        startIcon={<CloseIcon />}
                        variant="outlined"
                        size="small"
                      >
                        Close
                      </Button>
                    </Stack>
                  </DialogActions>
                </Dialog>

                {/* Confirm Delete Image Dialog */}
                <Dialog open={openConfirmDialogDelete} onClose={handleCloseConfirmDialogDelete}>
                  <DialogTitle>Confirm Deletion</DialogTitle>
                  <DialogContent>
                    <Typography>Are you sure you want to delete this image?</Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseConfirmDialogDelete} color="primary">
                      Cancel
                    </Button>
                    <Button
                      onClick={() => {
                        // Delete the image depending on which preview is open
                        if (previewTarget === 'sender') {
                          setSenderImageFile(null);
                          setSenderImagePreview('');
                          setFieldValue('IdCardNo', '');
                        } else if (previewTarget === 'receiver') {
                          setReceiverImageFile(null);
                          setReceiverImagePreview('');
                          setFieldValue('RecIdCardNo', '');
                        } else {
                          setSelectedImageFile(null);
                          setImagePreview('');
                        }
                        setOpenDialogPreview(false);
                        handleCloseDialogPreview();
                        handleCloseConfirmDialogDelete();
                      }}
                      color="error"
                    >
                      Delete
                    </Button>
                  </DialogActions>
                </Dialog>

                {/* Confirmation Dialog for Change Country */}
                <Dialog open={openConfirmDialog1} onClose={handleCloseConfirmDialog1}>
                  <DialogTitle>Change Country</DialogTitle>
                  <DialogContent>
                    <Typography>{changeContent}</Typography>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseConfirmDialog1} color="warning">
                      Close
                    </Button>
                    {/* <Button onClick={() => changeCountry(setFieldValue)} color="error">
                      Change
                    </Button> */}
                  </DialogActions>
                </Dialog>

                {/* Courier Shipper Price Dialog */}
               {/* Courier Shipper Price Dialog */}
{cardToggleCourier && shipperPriceData.length > 0 && shipperPriceData[0].weight > 0 && (
  <div style={{ position: 'fixed', bottom: 12, right: 12, zIndex: 999 }}>
    <Paper
      elevation={isMinimized ? 1 : 3}
      sx={{
        width: isMinimized ? '200px' : '300px',
        height: isMinimized ? 'auto' : 'auto',
        maxHeight: isMinimized ? '60px' : '400px',
        borderRadius: '16px',
        backgroundColor: '#1a1a2e',
        color: 'white',
        padding: isMinimized ? '12px 16px' : 3,
        position: 'relative',
        textAlign: 'center',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        overflow: 'hidden',
        transform: isMinimized ? 'scale(0.95)' : 'scale(1)',
        opacity: isMinimized ? 0.9 : 1,
      }}
    >
      {/* Header Section */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          mb: isMinimized ? 0 : 2,
          transition: 'margin-bottom 0.3s ease',
        }}
      >
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'rgba(255, 255, 255, 0.7)', 
            fontWeight: 500,
            fontSize: isMinimized ? '0.875rem' : '0.9rem',
            transition: 'font-size 0.3s ease',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {isMinimized ? (
            `Price Details - ${shipperPriceData.length} options`
          ) : (
            'Price Details'
          )}
        </Typography>
        
        <Stack direction="row" spacing={0.5}>
          {/* Minimize Button */}
          <IconButton
            aria-label="minimize"
            onClick={() => setIsMinimized(!isMinimized)}
            sx={{
              color: 'white',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.4)',
              },
              padding: '4px',
              fontSize: '0.875rem',
              transition: 'transform 0.3s ease',
              transform: isMinimized ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
            size="small"
          >
            <ExpandLessIcon />
          </IconButton>
          
          {/* Close Button */}
          <IconButton
            aria-label="close"
            onClick={() => setCardToggleCourier(false)}
            sx={{
              color: 'white',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.4)',
              },
              padding: '4px',
              fontSize: '0.875rem',
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </Stack>

      {/* Content Container */}
      <Box
        sx={{
          maxHeight: isMinimized ? '0px' : '400px',
          opacity: isMinimized ? 0 : 1,
          overflow: 'hidden',
          transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
          visibility: isMinimized ? 'hidden' : 'visible',
        }}
      >
        {/* Title */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: 'bold',
            mb: 2,
            textAlign: 'center',
            fontSize: '1.1rem',
            opacity: isMinimized ? 0 : 1,
            transform: isMinimized ? 'translateY(-10px)' : 'translateY(0)',
            transition: 'opacity 0.3s ease, transform 0.3s ease',
          }}
        >
          {`${getCountryName(values.senderCountry)} - ${getCountryName(values.receiverCountry)} for ${shipperPriceData[0].weight || 0} kgs (approximately)`}
        </Typography>

        {/* Scrollable Content */}
        <Box
          sx={{
            maxHeight: '200px',
            overflowY: 'auto',
            opacity: isMinimized ? 0 : 1,
            transform: isMinimized ? 'translateY(-20px)' : 'translateY(0)',
            transition: 'opacity 0.4s ease 0.1s, transform 0.4s ease 0.1s',
            '&::-webkit-scrollbar': {
              width: '6px',
            },
            '&::-webkit-scrollbar-track': {
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '3px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: 'rgba(255, 255, 255, 0.3)',
              borderRadius: '3px',
              '&:hover': {
                background: 'rgba(255, 255, 255, 0.4)',
              },
            },
          }}
        >
          {/* Dynamic Mapping of Shipper Prices */}
          {shipperPriceData.map((item, index) => {
            const isSelected = values.shipper === item.ShipperLinerName;
            
            return (
              <Stack
                key={index}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  padding: '8px 16px',
                  borderBottom: index < shipperPriceData.length - 1 ? '1px solid rgba(255, 255, 255, 0.2)' : 'none',
                  backgroundColor: isSelected ? 'rgba(255, 255, 255, 0.15)' : 'transparent',
                  '&:hover': {
                    backgroundColor: isSelected ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.05)',
                    cursor: 'pointer',
                  },
                  transition: 'all 0.2s ease',
                  opacity: isMinimized ? 0 : 1,
                  transform: isMinimized ? 'translateY(-10px)' : 'translateY(0)',
                  animation: isMinimized ? 'none' : `fadeInUp 0.3s ease ${index * 0.05}s both`,
                }}
                onClick={() => {
                  if (!isMinimized) {
                    setFieldValue('shipper', item.ShipperLinerName || '');
                    setShipperId(item.ShipperLinerId);
                    setFieldTouched('shipper', true);
                               setTimeout(() => {
                                     setIsMinimized(!isMinimized)
                                  },800)
                  }
                }}
              >
                {/* Left side: Radio button and Shipper Name */}
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Box
                    sx={{
                      width: 20,
                      height: 20,
                      borderRadius: '50%',
                      border: '2px solid rgba(255, 255, 255, 0.5)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mr: 1,
                      transition: 'all 0.2s ease',
                    }}
                  >
                    {isSelected && (
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: '50%',
                          backgroundColor: 'white',
                          transition: 'all 0.2s ease',
                        }}
                      />
                    )}
                  </Box>
                  <Typography
                    variant="body2"
                    gutterBottom
                    sx={{ 
                      color: 'white',
                      fontWeight: isSelected ? 600 : 400,
                      transition: 'all 0.2s ease',
                    }}
                  >
                    {item.ShipperLinerName || ''}
                  </Typography>
                </Stack>

                {/* Right side: Price */}
                <Typography 
                  variant="body2" 
                  gutterBottom 
                  sx={{ 
                    color: 'white',
                    fontWeight: isSelected ? 600 : 400,
                    transition: 'all 0.2s ease',
                  }}
                >
                  {item.symbol}{numeral(item.Price).format('0,0.00')}
                </Typography>
              </Stack>
            );
          })}
        </Box>
      </Box>
      
      {/* Add CSS animation keyframes */}
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </Paper>
  </div>
)}

                

                {/* Shipper Price Dialog */}
              {/* Cargo Shipper Price Dialog */}
{cardToggleCargo && shipperPriceData?.output?.length > 0 && (
  <div style={{ position: 'fixed', bottom: 12, right: 12, zIndex: 999 }}>
    <Paper
      elevation={isShipperCardMinimized ? 1 : 3}
      sx={{
        width: isShipperCardMinimized ? '200px' : '350px',
        height: isShipperCardMinimized ? 'auto' : 'auto',
        maxHeight: isShipperCardMinimized ? '60px' : '400px',
        borderRadius: '16px',
        backgroundColor: '#1a1a2e',
        color: 'white',
        padding: isShipperCardMinimized ? '12px 16px' : 3,
        position: 'relative',
        textAlign: 'center',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        overflow: 'hidden',
        transform: isShipperCardMinimized ? 'scale(0.95)' : 'scale(1)',
        opacity: isShipperCardMinimized ? 0.9 : 1,
      }}
    >
      {/* Header Section */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          mb: isShipperCardMinimized ? 0 : 2,
          transition: 'margin-bottom 0.3s ease',
        }}
      >
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'rgba(255, 255, 255, 0.7)', 
            fontWeight: 500,
            fontSize: isShipperCardMinimized ? '0.875rem' : '0.9rem',
            transition: 'font-size 0.3s ease',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {isShipperCardMinimized ? (
            `Price Details - ${shipperPriceData?.output?.length || 0} options`
          ) : (
            'Price Details'
          )}
        </Typography>
        
        <Stack direction="row" spacing={0.5}>
          {/* Minimize Button */}
          <IconButton
            aria-label="minimize"
            onClick={() => setIsShipperCardMinimized(!isShipperCardMinimized)}
            sx={{
              color: 'white',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.4)',
              },
              padding: '4px',
              fontSize: '0.875rem',
              transition: 'transform 0.3s ease',
              transform: isShipperCardMinimized ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
            size="small"
          >
            <ExpandLessIcon />
          </IconButton>
          
          {/* Close Button */}
          <IconButton
            aria-label="close"
            onClick={() => setCardToggleCargo(false)}
            sx={{
              color: 'white',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.4)',
              },
              padding: '4px',
              fontSize: '0.875rem',
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </Stack>

      {/* Content Container */}
      <Box
        sx={{
          maxHeight: isShipperCardMinimized ? '0px' : '400px',
          opacity: isShipperCardMinimized ? 0 : 1,
          overflow: 'hidden',
          transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
          visibility: isShipperCardMinimized ? 'hidden' : 'visible',
        }}
      >
        {/* Title */}
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 'bold',
            textAlign: 'left',
            opacity: isShipperCardMinimized ? 0 : 1,
            transform: isShipperCardMinimized ? 'translateY(-10px)' : 'translateY(0)',
            transition: 'opacity 0.3s ease, transform 0.3s ease',
          }}
        >
          {`${getCountryName(values.senderCountry)} - ${getCountryName(values.receiverCountry)} (approximately)`}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 'bold',
            mb: 2,
            textAlign: 'left',
            opacity: isShipperCardMinimized ? 0 : 1,
            transform: isShipperCardMinimized ? 'translateY(-10px)' : 'translateY(0)',
            transition: 'opacity 0.3s ease, transform 0.3s ease',
          }}
        >
          {`CBM - ${shipperPriceData.totalCBM || 0}`}
        </Typography>

        {/* Scrollable Content */}
        <Box
          sx={{
            maxHeight: '200px',
            overflowY: 'auto',
            opacity: isShipperCardMinimized ? 0 : 1,
            transform: isShipperCardMinimized ? 'translateY(-20px)' : 'translateY(0)',
            transition: 'opacity 0.4s ease 0.1s, transform 0.4s ease 0.1s',
            '&::-webkit-scrollbar': {
              width: '6px',
            },
            '&::-webkit-scrollbar-track': {
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '3px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: 'rgba(255, 255, 255, 0.3)',
              borderRadius: '3px',
              '&:hover': {
                background: 'rgba(255, 255, 255, 0.4)',
              },
            },
          }}
        >
          {/* Dynamic Mapping of Shipper Prices */}
          {shipperPriceData?.output?.map((item, index) => {
            const isSelected = values.shipper === item.ShipperLinerName;
            console.log(isSelected,"select ")
            
            return (
              <Stack
                key={index}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  padding: '8px 16px',
                  borderBottom: index < shipperPriceData?.output.length - 1 ? '1px solid rgba(255, 255, 255, 0.2)' : 'none',
                  backgroundColor: isSelected ? 'rgba(255, 255, 255, 0.15)' : 'transparent',
                  '&:hover': {
                    backgroundColor: isSelected ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.05)',
                    cursor: 'pointer',
                  },
                  transition: 'all 0.2s ease',
                  opacity: isShipperCardMinimized ? 0 : 1,
                  transform: isShipperCardMinimized ? 'translateY(-10px)' : 'translateY(0)',
                  animation: isShipperCardMinimized ? 'none' : `fadeInUp 0.3s ease ${index * 0.05}s both`,
                }}
                onClick={() => {
                  if (!isShipperCardMinimized) {
                    setFieldValue('shipper', item.ShipperLinerName || '');
                    setShipperId(item.ShipperLinerId || 0);
                    setFieldTouched('shipper', true);
                               setTimeout(() => {
                                     setIsShipperCardMinimized(!isShipperCardMinimized)
                                  },800)
                  }
                }}
              >
                {/* Left side: Radio button and Shipper Name */}
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Box
                    sx={{
                      width: 20,
                      height: 20,
                      borderRadius: '50%',
                      border: '2px solid rgba(255, 255, 255, 0.5)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mr: 1,
                      transition: 'all 0.2s ease',
                    }}
                  >
                    {isSelected && (
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: '50%',
                          backgroundColor: 'white',
                          transition: 'all 0.2s ease',
                        }}
                      />
                    )}
                  </Box>
                  <Typography
                    variant="body2"
                    gutterBottom
                    sx={{ 
                      color: 'white',
                      fontWeight: isSelected ? 600 : 400,
                      transition: 'all 0.2s ease',
                    }}
                  >
                    {item.ShipperLinerName || ''}
                  </Typography>
                </Stack>

                {/* Right side: Price */}
                <Typography 
                  variant="body2" 
                  gutterBottom 
                  sx={{ 
                    color: 'white',
                    fontWeight: isSelected ? 600 : 400,
                    transition: 'all 0.2s ease',
                  }}
                >
                  {item.Symbol}{numeral(item.totalNetRate).format('0,0.00')}
                </Typography>
              </Stack>
            );
          })}
        </Box>
      </Box>
      
      {/* Add CSS animation keyframes */}
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </Paper>
  </div>
)}
              </Form>
            )}
          </Formik>{' '}
        </Container>
      </Container>
    </>
  );
};

export default AddBookingForCourierAndCargoOrderCreation;
